(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar"]) return;
  try {
    
  class AnnouncementBar extends HTMLElement {
    connectedCallback() {
      // Only remember dismissal when the bar is actually dismissible.
      // Otherwise always show it, ignoring any past dismissal flag.
      if (this.dataset.dismissible !== 'true') return;

      this.storageKey = 'evenli:announcement-dismissed';
      this.value = this.dataset.key || '';

      try {
        if (window.localStorage.getItem(this.storageKey) === this.value) {
          this.hidden = true;
          return;
        }
      } catch (e) {}

      const close = this.querySelector('.announcement__close');
      if (close) {
        close.addEventListener('click', () => {
          this.hidden = true;
          try {
            window.localStorage.setItem(this.storageKey, this.value);
          } catch (e) {}
        });
      }
    }
  }

  if (!customElements.get('announcement-bar')) {
    customElements.define('announcement-bar', AnnouncementBar);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["article"]) return;
  try {
    
  /* Table of contents, built from the rendered body rather than authored by
     hand — the article content comes from the admin, so the headings are not
     knowable at template time. Stays hidden unless there are at least two
     sections, because a one-item contents list is noise. */
  (function () {
    function init() {
      var body = document.getElementById('article-body');
      var toc = document.getElementById('article-toc');
      if (!body || !toc) return;

      var headings = body.querySelectorAll('h2');
      if (headings.length < 2) return;

      var compact = document.getElementById('article-toc-compact');
      var lists = [toc.querySelector('.article__toc-list')];
      if (compact) lists.push(compact.querySelector('.article__toc-list'));
      var links = [];

      headings.forEach(function (heading, i) {
        if (!heading.id) {
          heading.id = 'section-' + (i + 1);
        }
        lists.forEach(function (list) {
          var li = document.createElement('li');
          var a = document.createElement('a');
          a.href = '#' + heading.id;
          a.textContent = heading.textContent;
          li.appendChild(a);
          list.appendChild(li);
          links.push({ link: a, heading: heading });
        });
      });

      toc.hidden = false;
      if (compact) {
        compact.hidden = false;
        /* Jumping to a section folds the card again behind the reader. */
        compact.addEventListener('click', function (event) {
          if (event.target.closest('a')) compact.open = false;
        });
      }

      /* Highlight the section currently in view. rootMargin pulls the trigger
         line near the top of the viewport so the highlight matches what the
         reader is actually looking at, not what is merely on screen. */
      if (!('IntersectionObserver' in window)) return;

      var observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (!entry.isIntersecting) return;
            links.forEach(function (item) {
              item.link.classList.toggle('is-current', item.heading === entry.target);
            });
          });
        },
        { rootMargin: '-10% 0px -80% 0px' },
      );

      headings.forEach(function (heading) {
        observer.observe(heading);
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cancel-contract"] && !Shopify.designMode) return;
  try {
    
  /* Keep what was sent, with the moment it was sent, across the reload that
     follows the post, then show it so it can be printed or saved as PDF. */
  (function () {
    var KEY = 'evenli:cancel';
    var form = document.querySelector('[data-cancel-form]');
    if (!form) return;

    form.addEventListener('submit', function () {
      var rows = [];
      var seen = {};
      form.querySelectorAll('[data-cancel-field]').forEach(function (field) {
        if (field.type === 'radio' && !field.checked) return;
        if (!field.value || seen[field.dataset.cancelField]) return;
        seen[field.dataset.cancelField] = true;
        rows.push([field.dataset.cancelField, field.value]);
      });
      rows.push([form.dataset.cancelSentLabel || '', new Date().toLocaleString(document.documentElement.lang || 'de')]);
      try {
        sessionStorage.setItem(KEY, JSON.stringify(rows));
      } catch (e) {}
    });

    var summary = form.querySelector('[data-cancel-summary]');
    if (summary) {
      var rows = [];
      try {
        rows = JSON.parse(sessionStorage.getItem(KEY) || '[]');
      } catch (e) {}
      rows.forEach(function (row) {
        var dt = document.createElement('dt');
        var dd = document.createElement('dd');
        dt.textContent = row[0];
        dd.textContent = row[1];
        summary.append(dt, dd);
      });
      summary.hidden = rows.length === 0;
    }

    var print = form.querySelector('[data-cancel-print]');
    if (print)
      print.addEventListener('click', function () {
        window.print();
      });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cart-drawer"]) return;
  try {
    
  (function () {
    const CART_MOVE_MS = 460; // the longer of the two slides

    class CartDrawer extends HTMLElement {
      connectedCallback() {
        if (this.initialised) return;
        this.initialised = true;

        this.layer = this.querySelector('.cd__layer');
        this.panel = this.querySelector('[data-cart-panel]');
        this.sectionId = this.dataset.sectionId;
        this.closeTimer = 0;
        // Every cart request takes a ticket; only the newest may write to the
        // DOM, so the drawer can stay interactive while a request is in flight.
        this.requestId = 0;

        this.onDocSubmit = this.onDocSubmit.bind(this);
        this.onDocClick = this.onDocClick.bind(this);

        this.addEventListener('click', this.onClick.bind(this));
        this.addEventListener('change', this.onChange.bind(this));
        this.panel.addEventListener('transitionend', (event) => {
          if (event.target === this.panel && this.dataset.state === 'closed') this.finishClose();
        });
        // Esc closes; Tab stays inside the panel while it is open.
        this.onKeydown = this.onKeydown.bind(this);

        document.addEventListener('submit', this.onDocSubmit);
        document.addEventListener('click', this.onDocClick);

        // The cart page changes the cart without the drawer; re-render quietly
        // so opening the drawer there never shows old quantities.
        this.onExternal = (event) => {
          if (event.detail && event.detail.source === 'cart-page') this.refresh(true);
        };
        document.addEventListener('cart:updated', this.onExternal);
      }

      disconnectedCallback() {
        document.removeEventListener('submit', this.onDocSubmit);
        document.removeEventListener('click', this.onDocClick);
        document.removeEventListener('cart:updated', this.onExternal);
        document.removeEventListener('keydown', this.onKeydown);
        clearTimeout(this.closeTimer);
      }

      /* ---------- events ---------- */

      onDocSubmit(event) {
        const form = event.target.closest('form[action*="/cart/add"]');
        // Forms marked data-direct-checkout post normally: Shopify adds the item
        // and its return_to field sends the customer straight to checkout.
        if (!form || form.hasAttribute('data-direct-checkout')) return;
        event.preventDefault();
        this.addFromForm(form);
      }

      onDocClick(event) {
        const toggle = event.target.closest('[data-cart-toggle]');
        if (!toggle || this.contains(toggle)) return;
        event.preventDefault();
        this.open(toggle);
      }

      onClick(event) {
        if (event.target.closest('[data-cart-close]')) {
          this.close();
          return;
        }
        const swap = event.target.closest('[data-bundle-swap]');
        if (swap) {
          this.swapBundle(swap);
          return;
        }
        const remove = event.target.closest('[data-cart-remove]');
        if (remove) {
          this.changeLine(this.keyOf(remove), 0);
          return;
        }
        const step = event.target.closest('[data-qty-step]');
        if (step) {
          const input = step.parentElement.querySelector('[data-qty-input]');
          const next = Math.max(0, (parseInt(input.value, 10) || 0) + parseInt(step.dataset.qtyStep, 10));
          // Show the new number on the tap, not after the round-trip.
          input.value = next;
          this.changeLine(this.keyOf(step), next);
        }
      }

      onChange(event) {
        const input = event.target.closest('[data-qty-input]');
        if (!input) return;
        const value = parseInt(input.value, 10);
        this.changeLine(this.keyOf(input), Number.isNaN(value) || value < 0 ? 0 : value);
      }

      keyOf(node) {
        // The line key, not its position: removing one line renumbers the rest.
        return node.closest('[data-line]').dataset.key;
      }

      /* ---------- requests ---------- */

      async refresh(quiet) {
        const request = ++this.requestId;
        try {
          const response = await fetch(window.location.pathname + '?sections=' + encodeURIComponent(this.sectionId), {
            credentials: 'same-origin',
          });
          const sections = await response.json();
          if (request === this.requestId) this.render({ sections }, quiet);
        } catch (error) {
          /* the next add or change re-renders anyway */
        }
      }

      async addFromForm(form) {
        const request = ++this.requestId;
        const body = new FormData(form);
        body.append('sections', this.sectionId);
        body.append('sections_url', window.location.pathname);
        this.setLoading(true);
        // Open on the tap, not on the response.
        this.open(form.querySelector('[type="submit"]'));
        try {
          const response = await fetch(this.dataset.cartAddUrl + '.js', {
            method: 'POST',
            headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
            body,
          });
          const data = await response.json();
          if (request !== this.requestId) return;
          if (!response.ok) {
            await this.refresh(true);
            this.showError(data.description || data.message);
          } else {
            this.render(data);
          }
        } catch (error) {
          if (request === this.requestId) this.showError();
        } finally {
          if (request === this.requestId) this.setLoading(false);
        }
      }

      async changeLine(key, quantity) {
        const request = ++this.requestId;
        this.setLoading(true);
        try {
          const response = await fetch(this.dataset.cartChangeUrl + '.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({
              id: key,
              quantity: quantity,
              sections: this.sectionId,
              sections_url: window.location.pathname,
            }),
          });
          const data = await response.json();
          // A newer tap is already on its way; this one must not roll it back.
          if (request !== this.requestId) return;
          if (!response.ok) {
            this.showError(data.description || data.message);
          } else {
            this.render(data);
          }
        } catch (error) {
          if (request === this.requestId) this.showError();
        } finally {
          if (request === this.requestId) this.setLoading(false);
        }
      }

      /* Swaps a line for another variant or plan: the 3-month pack (same purchase
         type) or the subscription upgrade (same variant, a selling plan, same
         quantity). Remove the old line, add the new one, render. */
      async swapBundle(button) {
        const request = ++this.requestId;
        this.setLoading(true);
        try {
          const removed = await fetch(this.dataset.cartChangeUrl + '.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ id: button.dataset.key, quantity: 0 }),
          });
          if (!removed.ok) throw new Error('remove ' + removed.status);
          const item = { id: Number(button.dataset.variant), quantity: Number(button.dataset.qty || 1) };
          if (button.dataset.plan) item.selling_plan = Number(button.dataset.plan);
          const response = await fetch(this.dataset.cartAddUrl + '.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({
              items: [item],
              sections: this.sectionId,
              sections_url: window.location.pathname,
            }),
          });
          const data = await response.json();
          if (request !== this.requestId) return;
          if (!response.ok) {
            await this.refresh(true);
            this.showError(data.description || data.message);
          } else {
            this.render(data);
          }
        } catch (error) {
          if (request === this.requestId) {
            await this.refresh(true);
            this.showError();
          }
        } finally {
          if (request === this.requestId) this.setLoading(false);
        }
      }

      /* ---------- rendering ---------- */

      render(data, quiet) {
        const markup = data.sections && data.sections[this.sectionId];
        if (!markup) return;
        const doc = new DOMParser().parseFromString(markup, 'text/html');
        const fresh = doc.getElementById('CartDrawerContents');
        const current = this.querySelector('#CartDrawerContents');
        if (!fresh || !current) return;
        current.replaceWith(fresh);
        // The drawer is usually already sliding in when the cart answers; fade
        // the new contents in so they settle instead of snapping into place.
        if (fresh.animate && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
          fresh.animate([{ opacity: 0.35 }, { opacity: 1 }], { duration: 240, easing: 'ease-out' });
        }
        this.publishCount(fresh.dataset.cartCount, quiet);
      }

      publishCount(count, quiet) {
        const total = parseInt(count, 10) || 0;
        document.querySelectorAll('[data-cart-count-target]').forEach((node) => {
          node.textContent = total;
          node.hidden = total === 0;
        });
        if (!quiet) document.dispatchEvent(new CustomEvent('cart:updated', { detail: { count: total } }));
      }

      setLoading(state) {
        this.dataset.loading = state ? 'true' : 'false';
      }

      showError(message) {
        const el = this.querySelector('[data-cart-error]');
        if (!el) return;
        el.textContent = message || this.dataset.errorText;
        el.hidden = false;
      }

      /* ---------- open / close ---------- */

      // The page behind must not scroll along with the cart. Hiding the
      // overflow also removes the scrollbar, which would shift the whole page
      // sideways by its width — so that width is put back as padding.
      lockScroll() {
        const root = document.documentElement;
        const gutter = window.innerWidth - root.clientWidth;
        root.style.overflow = 'hidden';
        document.body.style.overflow = 'hidden';
        if (gutter > 0) document.body.style.paddingRight = gutter + 'px';
      }

      unlockScroll() {
        document.documentElement.style.overflow = '';
        document.body.style.overflow = '';
        document.body.style.paddingRight = '';
      }

      get isOpen() {
        return this.dataset.state === 'open';
      }

      open(trigger) {
        if (trigger) this.lastTrigger = trigger;
        clearTimeout(this.closeTimer);
        if (this.isOpen) return;
        this.layer.inert = false;
        this.lockScroll();
        document.addEventListener('keydown', this.onKeydown);
        // The panel is already rendered off-screen, so changing the state is
        // all it takes for the transition to run from its current position.
        this.dataset.state = 'open';
        requestAnimationFrame(() => this.panel.focus({ preventScroll: true }));
      }

      close() {
        if (!this.isOpen) return;
        this.dataset.state = 'closed';
        this.layer.inert = true;
        document.removeEventListener('keydown', this.onKeydown);
        // transitionend finishes the close; this is the safety net.
        clearTimeout(this.closeTimer);
        this.closeTimer = setTimeout(() => this.finishClose(), CART_MOVE_MS + 150);
      }

      finishClose() {
        clearTimeout(this.closeTimer);
        if (this.isOpen) return;
        // The scrollbar comes back only once the panel is gone, so the page
        // never shifts while it is still sliding out.
        this.unlockScroll();
        if (this.lastTrigger && this.lastTrigger.isConnected) this.lastTrigger.focus({ preventScroll: true });
      }

      onKeydown(event) {
        if (event.key === 'Escape') {
          event.preventDefault();
          this.close();
          return;
        }
        if (event.key !== 'Tab') return;
        const focusable = Array.from(
          this.panel.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]), [tabindex="0"]'),
        ).filter((node) => node.offsetParent !== null);
        if (!focusable.length) return;
        const first = focusable[0];
        const last = focusable[focusable.length - 1];
        if (event.shiftKey && (document.activeElement === first || document.activeElement === this.panel)) {
          event.preventDefault();
          last.focus();
        } else if (!event.shiftKey && document.activeElement === last) {
          event.preventDefault();
          first.focus();
        }
      }
    }

    if (!customElements.get('cart-drawer')) customElements.define('cart-drawer', CartDrawer);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cart"]) return;
  try {
    
  /* Cart page: quantity steppers, typed quantities and remove links update
     the cart in place. Each change posts to /cart/change.js, then the section
     is re-rendered by Shopify and swapped in, so prices, discounts and the
     shipping bar are always Shopify's own numbers. */
  class CartPage extends HTMLElement {
    connectedCallback() {
      // Every change takes a ticket; only the newest may write to the DOM, so
      // the steppers stay live while a request is in flight.
      this.requestId = 0;
      this.addEventListener('click', this.onClick.bind(this));
      this.addEventListener('change', this.onChange.bind(this));
      // Keep in step with the cart drawer.
      this._onExternal = (event) => {
        if (!event.detail || event.detail.source !== 'cart-page') this.refresh();
      };
      document.addEventListener('cart:updated', this._onExternal);
    }

    disconnectedCallback() {
      document.removeEventListener('cart:updated', this._onExternal);
    }

    onClick(event) {
      const step = event.target.closest('[data-qty-step]');
      if (step) {
        const line = step.closest('[data-line]');
        const input = line.querySelector('[data-qty-input]');
        const next = Math.max(0, (parseInt(input.value, 10) || 0) + Number(step.dataset.qtyStep));
        input.value = next;
        this.update(line, next);
        return;
      }
      const remove = event.target.closest('[data-cart-remove]');
      if (remove) {
        event.preventDefault();
        this.update(remove.closest('[data-line]'), 0);
      }
    }

    onChange(event) {
      const input = event.target.closest('[data-qty-input]');
      if (!input) return;
      const value = Math.max(0, parseInt(input.value, 10) || 0);
      this.update(input.closest('[data-line]'), value);
    }

    async update(lineEl, quantity) {
      if (!lineEl) return;
      const request = ++this.requestId;
      lineEl.setAttribute('aria-busy', 'true');
      try {
        // By key, not line number: removing one line renumbers the rest, and
        // a tap still in flight would then change the wrong product.
        const response = await fetch(this.dataset.changeUrl + '.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ id: lineEl.dataset.key, quantity }),
        });
        if (!response.ok) throw new Error('change failed');
        const cart = await response.json();
        if (request !== this.requestId) return;
        await this.refresh(request);
        document.querySelectorAll('[data-cart-count-target]').forEach((node) => {
          node.textContent = cart.item_count;
          node.hidden = cart.item_count === 0;
        });
        document.dispatchEvent(
          new CustomEvent('cart:updated', { detail: { count: cart.item_count, source: 'cart-page' } }),
        );
      } catch (e) {
        if (request !== this.requestId) return;
        lineEl.removeAttribute('aria-busy');
        const error = this.querySelector('[data-cart-error]');
        if (error) error.hidden = false;
      }
    }

    async refresh(request) {
      const id = this.dataset.section;
      const response = await fetch(window.location.pathname + '?sections=' + id);
      if (!response.ok) return;
      const data = await response.json();
      if (request !== undefined && request !== this.requestId) return;
      const doc = new DOMParser().parseFromString(data[id], 'text/html');
      const fresh = doc.getElementById('CartPageContents');
      const current = this.querySelector('#CartPageContents');
      if (fresh && current) current.replaceWith(fresh);
    }
  }
  if (!customElements.get('cart-page')) customElements.define('cart-page', CartPage);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-products"] && !Shopify.designMode) return;
  try {
    
  /* Arrow controls for the phone shelf (also used by the shop page, whose
     list marks itself with data-shelf-track). Scrolling stays native (momentum,
     snapping); the arrows just ask the scroller to move one card, and hide
     themselves at either end. */
  class BestSellersShelf extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-shelf-track]') || this.querySelector('.best-sellers__grid');
      this.prev = this.querySelector('[data-dir="-1"]');
      this.next = this.querySelector('[data-dir="1"]');
      if (!this.track || !this.prev || !this.next) return;

      this.onClick = (event) => {
        const dir = Number(event.currentTarget.dataset.dir);
        const card = this.track.querySelector('li');
        const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
        const step = card ? card.getBoundingClientRect().width + gap : this.track.clientWidth * 0.8;
        const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.track.scrollBy({ left: dir * step, behavior: reduce ? 'auto' : 'smooth' });
      };
      this.update = () => {
        this.frame = null;
        const max = this.track.scrollWidth - this.track.clientWidth;
        this.prev.disabled = this.track.scrollLeft <= 4;
        this.next.disabled = this.track.scrollLeft >= max - 4;
      };
      this.onScroll = () => {
        if (!this.frame) this.frame = requestAnimationFrame(this.update);
      };

      this.prev.addEventListener('click', this.onClick);
      this.next.addEventListener('click', this.onClick);
      this.track.addEventListener('scroll', this.onScroll, { passive: true });
      this.resizeObserver = new ResizeObserver(this.update);
      this.resizeObserver.observe(this.track);
      this.update();
    }

    disconnectedCallback() {
      this.track?.removeEventListener('scroll', this.onScroll);
      this.resizeObserver?.disconnect();
    }
  }
  if (!customElements.get('best-sellers-shelf')) {
    customElements.define('best-sellers-shelf', BestSellersShelf);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  /* <details> snaps open with nothing in between, and its height cannot be
     transitioned in CSS. This drives the height with the Web Animations API
     instead, which is interruptible by construction: a panel caught halfway
     reverses from the height it is actually at rather than restarting. */
  class FooterAccordion extends HTMLElement {
    connectedCallback() {
      if (this.initialised) return;
      this.initialised = true;

      this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

      this.querySelectorAll('details').forEach((details) => {
        const summary = details.querySelector('summary');
        const panel = details.querySelector('.footer__col-links');
        if (!summary || !panel) return;

        if (details.open) details.classList.add('is-open');

        summary.addEventListener('click', (event) => {
          event.preventDefault();
          this.toggle(details, panel);
        });
      });
    }

    toggle(details, panel) {
      const opening = !details.classList.contains('is-open');

      // Measure before cancelling, so an interrupted panel starts from the
      // height on screen and never jumps.
      const start = panel.getBoundingClientRect().height;
      if (panel.anim) panel.anim.cancel();

      details.classList.toggle('is-open', opening);

      // The element has to be open for the content to have a height at all.
      if (opening) details.open = true;

      if (this.reducedMotion.matches) {
        details.open = opening;
        return;
      }

      const end = opening ? panel.scrollHeight : 0;

      panel.style.overflow = 'hidden';
      panel.anim = panel.animate(
        {
          height: [start + 'px', end + 'px'],
          opacity: opening ? [0, 1] : [1, 0],
        },
        {
          duration: opening ? 260 : 200,
          // Outbound and return retrace the same curve, mirrored.
          easing: opening ? 'cubic-bezier(0.32, 0.72, 0, 1)' : 'cubic-bezier(1, 0, 0.68, 0.28)',
        },
      );

      panel.anim.onfinish = () => {
        panel.style.overflow = '';
        panel.style.height = '';
        panel.anim = null;
        if (!opening) details.open = false;
      };
    }
  }

  if (!customElements.get('footer-accordion')) {
    customElements.define('footer-accordion', FooterAccordion);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  /* Menu drawer. <details> opens and closes instantly, so the toggle is
     taken over: open sets [open], then adds .is-open on the next frame so the
     panel animates in; close removes .is-open, waits for the panel's
     transition, then drops [open]. The panel is pinned to the header's
     current bottom edge (the announcement bar may have scrolled away). */
  (function () {
    function initDrawer() {
      var disclosure = document.querySelector('.site-header__disclosure');
      var header = document.querySelector('.site-header');
      if (!disclosure || !header) return;
      var summary = disclosure.querySelector('summary');
      var drawer = disclosure.querySelector('.site-header__drawer');
      var closing = null;

      function place() {
        var bottom = Math.max(0, header.getBoundingClientRect().bottom);
        disclosure.style.setProperty('--drawer-top', bottom + 'px');
      }
      function open() {
        if (closing) {
          clearTimeout(closing);
          closing = null;
        }
        place();
        disclosure.open = true;
        summary.setAttribute('aria-expanded', 'true');
        requestAnimationFrame(function () {
          requestAnimationFrame(function () {
            disclosure.classList.add('is-open');
          });
        });
      }
      function close(returnFocus) {
        if (!disclosure.open || closing) return;
        disclosure.classList.remove('is-open');
        summary.setAttribute('aria-expanded', 'false');
        var done = function () {
          drawer.removeEventListener('transitionend', onEnd);
          clearTimeout(closing);
          closing = null;
          disclosure.open = false;
          if (returnFocus) summary.focus();
        };
        var onEnd = function (event) {
          if (event.target === drawer && event.propertyName === 'transform') done();
        };
        drawer.addEventListener('transitionend', onEnd);
        closing = setTimeout(done, 320);
      }

      summary.setAttribute('aria-expanded', 'false');
      summary.addEventListener('click', function (event) {
        event.preventDefault();
        if (disclosure.classList.contains('is-open')) close(false);
        else open();
      });
      drawer.addEventListener('click', function (event) {
        if (event.target.closest('a')) close(false);
      });
      window.addEventListener('resize', function () {
        if (disclosure.open) place();
      });
      document.addEventListener('keydown', function (event) {
        if (event.key === 'Escape' && disclosure.open) close(true);
      });
    }
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initDrawer);
    } else {
      initDrawer();
    }
  })();

  /* Floating chrome only earns its separation once content is actually
     passing underneath it, so the translucent material and its scroll edge
     are switched on at the point the header starts overlapping the page. */
  (function () {
    function init() {
      var header = document.querySelector('.site-header');
      if (!header) return;

      var ticking = false;

      function update() {
        ticking = false;
        header.classList.toggle('is-stuck', window.scrollY > 4);
      }

      window.addEventListener(
        'scroll',
        function () {
          if (ticking) return;
          ticking = true;
          requestAnimationFrame(update);
        },
        { passive: true },
      );

      update();
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["image-strip"] && !Shopify.designMode) return;
  try {
    
  /* Adds pointer dragging with momentum to a horizontally scrolling row.
     Touch already gets this from the browser, so the drag only arms for
     mouse and pen — the two inputs the platform leaves with no throw. */
  class DragScroller extends HTMLElement {
    connectedCallback() {
      if (this.initialised) return;
      this.initialised = true;

      this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.drag = null;
      this.frame = 0;

      this.addEventListener('pointerdown', this.onPointerDown.bind(this));
      this.addEventListener('pointermove', this.onPointerMove.bind(this));
      this.addEventListener('pointerup', this.onPointerEnd.bind(this));
      this.addEventListener('pointercancel', this.onPointerEnd.bind(this));
      this.addEventListener('scroll', this.updateEdges.bind(this), { passive: true });
      window.addEventListener('resize', this.updateEdges.bind(this), { passive: true });

      this.updateEdges();
    }

    /* Where a throw would come to rest — the exponential-decay model the
       platform uses for scroll, not the physics-textbook one. */
    project(velocity) {
      var d = 0.995;
      return ((velocity / 1000) * d) / (1 - d);
    }

    onPointerDown(event) {
      // Touch keeps the browser's own momentum; claiming it would be worse.
      if (event.pointerType === 'touch') return;
      cancelAnimationFrame(this.frame);
      this.dataset.gliding = 'false';

      this.drag = {
        id: event.pointerId,
        startX: event.clientX,
        startScroll: this.scrollLeft,
        moved: false,
        history: [{ x: event.clientX, t: event.timeStamp }],
      };
    }

    onPointerMove(event) {
      const drag = this.drag;
      if (!drag || event.pointerId !== drag.id) return;

      const dx = event.clientX - drag.startX;

      // A few pixels of hysteresis, so a click on an image is still a click.
      if (!drag.moved) {
        if (Math.abs(dx) < 6) return;
        drag.moved = true;
        // Capture can throw if the pointer is already gone; losing it only
        // costs tracking outside the element, so it must not kill the drag.
        try {
          this.setPointerCapture(drag.id);
        } catch (error) {
          /* keep dragging without capture */
        }
        this.dataset.dragging = 'true';
      }

      drag.history.push({ x: event.clientX, t: event.timeStamp });
      if (drag.history.length > 6) drag.history.shift();

      // Content tracks the pointer exactly: drag left, the row follows left.
      this.scrollLeft = drag.startScroll - dx;
    }

    onPointerEnd(event) {
      const drag = this.drag;
      if (!drag || event.pointerId !== drag.id) return;
      this.drag = null;
      if (!drag.moved) return;

      this.dataset.dragging = 'false';
      if (this.hasPointerCapture(drag.id)) this.releasePointerCapture(drag.id);

      const first = drag.history[0];
      const dt = event.timeStamp - first.t;
      const velocity = dt > 0 ? ((event.clientX - first.x) / dt) * 1000 : 0;

      if (this.reducedMotion.matches || Math.abs(velocity) < 80) {
        this.settle();
        return;
      }

      this.glide(this.scrollLeft - this.project(velocity));
    }

    /* Coasts to the projected resting point, then hands control back to
       scroll-snap so the row settles on a whole image rather than mid-frame. */
    glide(target) {
      const max = this.scrollWidth - this.clientWidth;
      const to = Math.max(0, Math.min(max, target));
      const from = this.scrollLeft;
      const distance = to - from;
      if (Math.abs(distance) < 1) return this.settle();

      this.dataset.gliding = 'true';
      const start = performance.now();
      const duration = Math.min(900, 260 + Math.abs(distance) * 0.6);

      const step = (now) => {
        const t = Math.min(1, (now - start) / duration);
        // Decelerating curve — fast at release, easing out to rest.
        const eased = 1 - Math.pow(1 - t, 3);
        this.scrollLeft = from + distance * eased;
        if (t < 1) {
          this.frame = requestAnimationFrame(step);
        } else {
          this.settle();
        }
      };
      this.frame = requestAnimationFrame(step);
    }

    settle() {
      this.dataset.gliding = 'false';
      this.updateEdges();
    }

    /* Only fade an edge that still has content behind it. */
    updateEdges() {
      const max = this.scrollWidth - this.clientWidth;
      const atStart = this.scrollLeft <= 2;
      const atEnd = this.scrollLeft >= max - 2;
      this.style.setProperty('--fade-start', atStart ? '0px' : '3.5rem');
      this.style.setProperty('--fade-end', atEnd ? '0px' : '3.5rem');
    }
  }

  if (!customElements.get('drag-scroller')) {
    customElements.define('drag-scroller', DragScroller);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["landing-offer"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('lp-sticky')) {
    customElements.define(
      'lp-sticky',
      class extends HTMLElement {
        connectedCallback() {
          this.hero = document.querySelector('.lp-hero');
          this.offer = document.querySelector('[data-lp-offer]');
          this.update = this.update.bind(this);
          this.onScroll = () => {
            if (this.frame) return;
            this.frame = requestAnimationFrame(() => {
              this.frame = null;
              this.update();
            });
          };
          // Kept out of the layout until it is first needed, so it never
          // flashes in on load; from then on it slides via a class.
          this.hidden = false;
          window.addEventListener('scroll', this.onScroll, { passive: true });
          window.addEventListener('resize', this.onScroll, { passive: true });
          this.update();
        }

        disconnectedCallback() {
          window.removeEventListener('scroll', this.onScroll);
          window.removeEventListener('resize', this.onScroll);
        }

        update() {
          const view = window.innerHeight;
          const heroGone = !this.hero || this.hero.getBoundingClientRect().bottom < 0;
          const offerAhead = !this.offer || this.offer.getBoundingClientRect().top > view;
          const show = heroGone && offerAhead;
          this.classList.toggle('is-visible', show);
          this.toggleAttribute('inert', !show);
        }
      },
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["logo-marquee"] && !Shopify.designMode) return;
  try {
    
  class MarqueeRow extends HTMLElement {}
  if (!customElements.get('marquee-row')) {
    customElements.define('marquee-row', MarqueeRow);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-faq"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init(root) {
      var buttons = root.querySelectorAll('[data-pfaq-cat]');
      var items = root.querySelectorAll('[data-pfaq-item]');
      if (!buttons.length || !items.length) return;

      function show(key) {
        buttons.forEach(function (b) {
          b.setAttribute('aria-pressed', String(b.dataset.pfaqCat === key));
        });
        var shown = 0;
        var limit = root.dataset.pfaqExpanded === 'true' ? Infinity : 5;
        items.forEach(function (it) {
          var match = it.dataset.pfaqItem === key;
          if (match) shown++;
          it.hidden = !match || shown > limit;
          /* Collapse on the way out. A details left open while hidden springs
             back open at full height when its category returns, which reads as
             the panel having been tampered with rather than filtered. */
          if (it.hidden) it.open = false;
        });
        /* Five questions per category, the rest one tap away — and the same
           button folds them away again once open. */
        if (more) {
          var expanded = root.dataset.pfaqExpanded === 'true';
          more.hidden = shown <= 5;
          more.textContent = expanded ? more.dataset.less : more.dataset.more;
          more.setAttribute('aria-expanded', String(expanded));
        }
      }
      var more = root.querySelector('[data-pfaq-more]');
      var current = null;
      if (more) {
        more.addEventListener('click', function () {
          root.dataset.pfaqExpanded = root.dataset.pfaqExpanded === 'true' ? 'false' : 'true';
          var active = root.querySelector('[data-pfaq-cat][aria-pressed="true"]');
          show(active ? active.dataset.pfaqCat : 'cat_1');
        });
      }

      buttons.forEach(function (b) {
        b.addEventListener('click', function () {
          show(b.dataset.pfaqCat);
        });
      });

      var first = root.querySelector('[data-pfaq-cat][aria-pressed="true"]');
      if (first) show(first.dataset.pfaqCat);
    }

    function boot() {
      document.querySelectorAll('.pfaq').forEach(init);
    }
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', boot);
    } else {
      boot();
    }
    document.addEventListener('shopify:section:load', function (e) {
      var el = e.target && e.target.querySelector('.pfaq');
      if (el) init(el);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-lab-tested"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init(root) {
      var dialog = root.querySelector('[data-lab-modal]');
      var opener = root.querySelector('[data-lab-open]');
      if (!dialog || !opener || typeof dialog.showModal !== 'function') return;

      opener.addEventListener('click', function (e) {
        e.preventDefault();
        dialog.showModal();
      });

      /* Click-outside-to-close. The dialog's own box is the only thing painted,
         so a click whose coordinates fall outside its rect landed on the
         backdrop — comparing against the target alone would also catch clicks on
         the padding of the dialog itself. */
      dialog.addEventListener('click', function (e) {
        var r = dialog.getBoundingClientRect();
        var outside = e.clientX < r.left || e.clientX > r.right || e.clientY < r.top || e.clientY > r.bottom;
        if (outside) dialog.close();
      });
    }

    function boot() {
      document.querySelectorAll('.lab').forEach(init);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', boot);
    } else {
      boot();
    }
    document.addEventListener('shopify:section:load', function (e) {
      if (e.target && e.target.querySelector('.lab')) init(e.target.querySelector('.lab'));
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-quiz"] && !Shopify.designMode) return;
  try {
    
  /* The questions, in path order, and when each is asked. Paths without a
     product end before the end, see quizDecide. */
  const QUIZ_QUESTIONS = [
    { id: 'goal' },
    { id: 'phase' },
    { id: 'age' },
    { id: 'training' },
    { id: 'supplements', multi: true },
    { id: 'routine' },
    { id: 'priority' },
    // Only when the seven answers lead to a product.
    {
      id: 'email',
      input: true,
      when: (a) => {
        const d = quizOutcome(a);
        return !!d && QUIZ_PRODUCTS.includes(d.outcome);
      },
    },
  ];
  const QUIZ_PRODUCTS = ['creatine', 'flora', 'balance'];
  const QUIZ_TOTAL = QUIZ_QUESTIONS.filter((q) => !q.input).length;
  const QUIZ_STORE = 'evenli:quiz:v2';
  const QUIZ_TTL = 7 * 24 * 3600 * 1000;

  function quizHas(value, item) {
    return typeof value === 'string' && value.split('+').includes(item);
  }

  /* The rules. Returns the outcome key and the notes to show, or null while
     the seven answers are unfinished. */
  function quizOutcome(a) {
    if (!a.goal || !a.phase) return null;
    if (a.phase === 'pregnancy') return { outcome: 'pregnancy', notes: [] };
    if (!a.age) return null;
    if (a.goal === 'learn') return { outcome: 'learn', notes: [] };
    if (!a.training) return null;
    if (a.goal === 'strength' && a.training === 'rarely') return { outcome: 'training', notes: [] };
    if (!a.supplements) return null;
    if (a.goal === 'basis' && quizHas(a.supplements, 'bvitamins')) return { outcome: 'b6', notes: [] };
    if (!a.routine || !a.priority) return null;

    const notes = [];
    if (a.goal === 'strength' && a.training === 'sometimes') notes.push('sometimes');
    if (a.goal === 'basis' && quizHas(a.supplements, 'multi')) notes.push('multi');
    if (a.routine === 'irregular') notes.push('irregular');
    const outcome = a.goal === 'strength' ? 'creatine' : a.goal === 'intimate' ? 'flora' : 'balance';
    return { outcome, notes };
  }

  /* A product result waits for the e-mail step (answered or skipped). */
  function quizDecide(a) {
    const d = quizOutcome(a);
    if (!d) return null;
    if (QUIZ_PRODUCTS.includes(d.outcome) && !('email' in a)) return null;
    return d;
  }

  class ProductQuiz extends HTMLElement {
    connectedCallback() {
      if (this.initialised) return;
      this.initialised = true;

      const strings = this.querySelector('[data-quiz-strings]');
      this.t = strings ? JSON.parse(strings.textContent) : {};
      this.steps = {};
      this.querySelectorAll('[data-quiz-question]').forEach((el) => (this.steps[el.dataset.quizQuestion] = el));
      this.results = Array.from(this.querySelectorAll('[data-quiz-result]'));
      this.bars = Array.from(this.querySelectorAll('[data-quiz-bar]'));
      this.counts = Array.from(this.querySelectorAll('[data-quiz-count]'));
      this.backs = Array.from(this.querySelectorAll('[data-quiz-back]'));

      this.addEventListener('click', this.onClick.bind(this));
      this.addEventListener('submit', this.onSubmit.bind(this));
      // Turnstile loads on the first touch of a sign-up form, not with the
      // page: no request to Cloudflare for visitors who never sign up.
      this.addEventListener('focusin', (event) => {
        const form = event.target.closest('[data-quiz-worker-form]');
        if (form) this.turnstile(form);
      });

      this.answers = this.load();
      // Back from a normal form post (after Shopify's bot check): the sign-up
      // went through, so the e-mail step counts as done.
      if (/[?&]customer_posted=true/.test(window.location.search)) {
        try {
          localStorage.setItem(QUIZ_STORE + ':email', '1');
        } catch (e) {
          /* fine */
        }
        const d = quizOutcome(this.answers);
        if (d && QUIZ_PRODUCTS.includes(d.outcome) && !('email' in this.answers)) {
          this.answers.email = '1';
          this.save();
        }
        if (window.history && window.history.replaceState) {
          window.history.replaceState(null, '', window.location.pathname);
        }
      }
      this.render(false);
    }

    /* ---- state ---- */

    path() {
      return QUIZ_QUESTIONS.filter((q) => !q.when || q.when(this.answers));
    }

    current() {
      return this.path().find((q) => !(q.id in this.answers)) || null;
    }

    /* Her answers say things like "Wechseljahre" or "Intimgesundheit", so on a
       shared device they must not wait for the next person: after QUIZ_TTL
       without a visit every quiz key is dropped. */
    load() {
      try {
        const seen = Number(localStorage.getItem(QUIZ_STORE + ':t')) || 0;
        if (seen && Date.now() - seen > QUIZ_TTL) {
          [QUIZ_STORE, QUIZ_STORE + ':email', QUIZ_STORE + ':code', QUIZ_STORE + ':t'].forEach((k) =>
            localStorage.removeItem(k),
          );
          return {};
        }
        const saved = JSON.parse(localStorage.getItem(QUIZ_STORE) || '{}');
        return typeof saved === 'object' && saved ? saved : {};
      } catch (e) {
        return {};
      }
    }

    save() {
      try {
        localStorage.setItem(QUIZ_STORE, JSON.stringify(this.answers));
        localStorage.setItem(QUIZ_STORE + ':t', String(Date.now()));
      } catch (e) {
        /* private mode: the quiz still works, it just forgets on reload */
      }
    }

    /* ---- events ---- */

    onClick(event) {
      const option = event.target.closest('[data-quiz-answer]');
      if (option) {
        const step = option.closest('[data-quiz-question]');
        if (step.hasAttribute('data-quiz-multi')) return this.toggle(step, option);
        option.classList.add('is-chosen');
        return this.answer(step.dataset.quizQuestion, option.dataset.quizAnswer);
      }
      const go = event.target.closest('[data-quiz-continue]');
      if (go) {
        const step = go.closest('[data-quiz-question]');
        const chosen = Array.from(step.querySelectorAll('[data-quiz-answer][aria-pressed="true"]')).map(
          (o) => o.dataset.quizAnswer,
        );
        if (chosen.length) this.answer(step.dataset.quizQuestion, chosen.join('+'));
        return;
      }
      if (event.target.closest('[data-quiz-skip]')) return this.answer('email', '');
      if (event.target.closest('[data-quiz-back]')) return this.goBack();
      if (event.target.closest('[data-quiz-restart]')) return this.reset();
    }

    /* Multi-select: "none" clears the rest, any other clears "none". */
    toggle(step, option) {
      const on = option.getAttribute('aria-pressed') !== 'true';
      if (option.dataset.quizAnswer === 'none' && on) {
        step.querySelectorAll('[data-quiz-answer]').forEach((o) => o.setAttribute('aria-pressed', 'false'));
      } else if (on) {
        const none = step.querySelector('[data-quiz-answer="none"]');
        if (none) none.setAttribute('aria-pressed', 'false');
      }
      option.setAttribute('aria-pressed', on ? 'true' : 'false');
      const any = step.querySelector('[data-quiz-answer][aria-pressed="true"]');
      const go = step.querySelector('[data-quiz-continue]');
      if (go) go.disabled = !any;
    }

    answer(question, value) {
      this.answers[question] = value;
      // Answers after this one no longer belong to the path.
      const ids = QUIZ_QUESTIONS.map((q) => q.id);
      ids.slice(ids.indexOf(question) + 1).forEach((id) => delete this.answers[id]);
      this.save();
      this.track('quiz_answer', { question });
      this.render(true);
    }

    goBack() {
      const answered = this.path().filter((q) => q.id in this.answers);
      const last = answered[answered.length - 1];
      if (!last) return;
      delete this.answers[last.id];
      this.save();
      this.render(true);
    }

    reset() {
      this.answers = {};
      this.save();
      this.querySelectorAll('.is-chosen').forEach((el) => el.classList.remove('is-chosen'));
      this.track('quiz_restart', {});
      this.render(true);
    }

    /* ---- rendering ---- */

    render(moveFocus) {
      const decision = quizDecide(this.answers);
      const question = decision ? null : this.current();

      Object.keys(this.steps).forEach((id) => {
        const step = this.steps[id];
        const show = !!(question && question.id === id);
        if (show && !step.classList.contains('is-active')) this.replay(step);
        step.classList.toggle('is-active', show);
        step.toggleAttribute('inert', !show);
        step.setAttribute('aria-hidden', show ? 'false' : 'true');
        const value = this.answers[id];
        step.querySelectorAll('[data-quiz-answer]').forEach((o) => {
          const on = quizHas(value, o.dataset.quizAnswer);
          o.classList.toggle('is-chosen', on);
          o.setAttribute('aria-pressed', on ? 'true' : 'false');
        });
        const go = step.querySelector('[data-quiz-continue]');
        if (go && !step.hasAttribute('data-quiz-input')) go.disabled = !value;
      });

      this.results.forEach((r) => (r.hidden = true));
      const panel = this.querySelector('[data-quiz-panel]');
      const wrap = this.querySelector('[data-quiz-results]');
      if (panel) panel.hidden = !!decision;
      if (wrap) wrap.hidden = !decision;
      if (decision) this.showResult(decision);

      // Progress: the position on the longest path, so the count never
      // shrinks under her feet. Shorter paths simply finish earlier.
      const done = this.path().filter((q) => !q.input && this.answers[q.id]).length;
      const total = QUIZ_TOTAL;
      // The current question counts as under way: question 1 shows 1/7, not 0.
      const fill = decision ? 1 : (done + 1) / total;
      this.bars.forEach((bar) => (bar.style.transform = 'scaleX(' + fill + ')'));
      if (this.t.progress) {
        const text = decision ? '' : this.t.progress.replace('[current]', done + 1).replace('[total]', total);
        this.counts.forEach((el) => (el.textContent = text));
      }
      this.backs.forEach((btn) => (btn.hidden = done === 0));

      if (moveFocus) {
        const target = this.querySelector(
          '[data-quiz-question].is-active [data-quiz-focus], [data-quiz-result]:not([hidden]) [data-quiz-focus]',
        );
        if (target) target.focus({ preventScroll: false });
      }
    }

    showResult(decision) {
      let result = this.results.find((r) => r.dataset.quizResult === decision.outcome);
      if (!result) result = this.results[0];
      if (!result) return;
      result.hidden = false;
      this.replay(result);

      // Her answers, as she read them, in path order.
      const profile = result.querySelector('[data-quiz-profile]');
      if (profile) {
        profile.textContent = '';
        this.path()
          .filter((q) => !q.input && this.answers[q.id])
          .forEach((q) => {
            const step = this.steps[q.id];
            if (!step) return;
            const texts = String(this.answers[q.id])
              .split('+')
              .map((v) => step.querySelector('[data-quiz-answer="' + v + '"] .quiz__option-text'))
              .filter(Boolean)
              .map((el) => el.textContent.trim());
            if (!texts.length) return;
            const row = document.createElement('div');
            row.className = 'quiz__profile-row';
            const dt = document.createElement('dt');
            dt.textContent = step.dataset.quizLabel || q.id;
            const dd = document.createElement('dd');
            dd.textContent = texts.join(', ');
            row.append(dt, dd);
            profile.append(row);
          });
      }

      const note = result.querySelector('[data-quiz-note]');
      if (note) {
        note.textContent = '';
        (decision.notes || []).forEach((key) => {
          const text = (this.t.note || {})[key];
          if (!text) return;
          const p = document.createElement('p');
          p.textContent = text;
          note.append(p);
        });
        note.hidden = !note.childElementCount;
      }

      // Lines and links that depend on one answer: data-quiz-when="q:a,b".
      result.querySelectorAll('[data-quiz-when]').forEach((el) => {
        const [q, list] = el.dataset.quizWhen.split(':');
        const value = this.answers[q];
        el.hidden = !list.split(',').some((v) => quizHas(value, v));
      });

      // The sign-up carries only 'newsletter, quiz' as customer tags.
      const tags = result.querySelector('[data-quiz-tags]');
      if (tags) tags.value = this.tagList();

      let subscribed = false;
      try {
        subscribed = localStorage.getItem(QUIZ_STORE + ':email') === '1';
      } catch (e) {
        /* fine */
      }
      if (subscribed) this.unlock(result, result.querySelector('[data-quiz-email-status]'));

      if (this.lastShown !== decision.outcome) {
        this.lastShown = decision.outcome;
        this.track('quiz_result', {});
      }
    }

    /* Only that she signed up, and where. Never her answers or her result:
       life phase, pregnancy or an intimate-health pick are health data
       (DSGVO Art. 9), and a customer tag would store them with her e-mail
       without the explicit consent that requires. */
    tagList() {
      return 'newsletter, quiz';
    }

    /* Re-run the entrance animation on an element that was just unhidden. */
    replay(el) {
      el.style.animation = 'none';
      void el.offsetWidth;
      el.style.animation = '';
    }

    /* ---- e-mail ---- */

    onSubmit(event) {
      const form = event.target.closest('[data-quiz-email-form]');
      if (!form) return;
      if (form.hasAttribute('data-quiz-worker-form')) return this.subscribeViaWorker(event, form);
      const tags = form.querySelector('[data-quiz-tags]');
      if (tags) tags.value = this.tagList();
      if (!window.fetch) return; // no fetch: the normal post still works
      event.preventDefault();
      const status =
        form.querySelector('[data-quiz-email-status]') || form.parentElement.querySelector('[data-quiz-email-status]');
      const button = form.querySelector('button[type="submit"]');
      button.disabled = true;
      fetch(form.action, {
        method: 'POST',
        body: new FormData(form),
        credentials: 'same-origin',
        redirect: 'follow',
        headers: { 'X-Requested-With': 'XMLHttpRequest' },
      })
        .then((response) => {
          if (response.url && response.url.includes('customer_posted=true')) return 'ok';
          // Shopify's bot check answers with a challenge page; only a real
          // page load can pass it, so hand the form over to the browser.
          if (response.url && response.url.includes('/challenge')) return 'challenge';
          return response.text().then((html) => {
            if (html.includes('customer_posted=true')) return 'ok';
            if (/challenge|hcaptcha|recaptcha/i.test(html)) return 'challenge';
            return 'error';
          });
        })
        .catch(() => 'error')
        .then((state) => {
          button.disabled = false;
          if (state === 'challenge') {
            this.save();
            form.submit();
            return;
          }
          if (state !== 'ok') {
            this.setStatus(status, this.t.email.error, 'error');
            return;
          }
          this.track('quiz_email', {});
          try {
            localStorage.setItem(QUIZ_STORE + ':email', '1');
          } catch (e) {
            /* fine */
          }
          const result = form.closest('[data-quiz-result]');
          if (result) return this.unlock(result, status);
          // The e-mail step: the result follows, already unlocked.
          this.answer('email', '1');
        });
    }

    /* The e-mail step through our worker: creates the customer tagged
       'quiz', mails her code and the product key the quiz picked, and only
       with her tick adds the newsletter (pending consent; Shopify mails the
       double opt-in confirmation). */
    subscribeViaWorker(event, form) {
      event.preventDefault();
      const input = form.querySelector('input[type="email"]');
      const status = form.querySelector('[data-quiz-email-status]');
      const button = form.querySelector('button[type="submit"]');
      const email = (input.value || '').trim();
      if (!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(email)) {
        this.setStatus(status, this.t.email.error, 'error');
        input.focus();
        return;
      }
      const endpoint = (this.dataset.codeEndpoint || '').replace(/\/$/, '');
      const optin = form.querySelector('[data-quiz-newsletter]');
      const pick = quizOutcome(this.answers);
      button.disabled = true;
      this.turnstileToken(form)
        .then((turnstile) =>
          fetch(endpoint + '/subscribe', {
            method: 'POST',
            mode: 'cors',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
              email,
              newsletter: !!(optin && optin.checked),
              result: pick && QUIZ_PRODUCTS.includes(pick.outcome) ? pick.outcome : null,
              locale: /^en/i.test(document.documentElement.lang) ? 'en' : 'de',
              turnstile,
            }),
          }),
        )
        .then((r) => (r.ok ? r.json() : Promise.reject(new Error('status ' + r.status))))
        .then((data) => {
          button.disabled = false;
          this.track('quiz_email', {});
          try {
            localStorage.setItem(QUIZ_STORE + ':email', '1');
            // Her personal code comes with the sign-up, one per address.
            if (data && data.code && data.endsAt) {
              localStorage.setItem(QUIZ_STORE + ':code', JSON.stringify({ code: data.code, endsAt: data.endsAt }));
            }
          } catch (e) {
            /* fine */
          }
          if (data && data.code && data.endsAt) this.issued = { code: data.code, endsAt: data.endsAt };
          const result = form.closest('[data-quiz-result]');
          if (result) return this.unlock(result, status);
          this.answer('email', '1');
        })
        .catch(() => {
          button.disabled = false;
          this.resetTurnstile(form);
          this.setStatus(status, this.t.email.error, 'error');
        });
    }

    /* ---- Turnstile (bot check for the worker sign-up) ---- */

    turnstile(form) {
      const key = this.dataset.turnstileKey;
      const box = form.querySelector('[data-quiz-turnstile]');
      if (!key || !box || form.turnstileState) return;
      const state = { id: null, token: null, waiters: [] };
      form.turnstileState = state;
      const render = () => {
        state.id = window.turnstile.render(box, {
          sitekey: key,
          size: 'flexible',
          appearance: 'interaction-only',
          language: document.documentElement.lang || 'auto',
          callback: (token) => {
            state.token = token;
            state.waiters.splice(0).forEach((resolve) => resolve(token));
          },
          'expired-callback': () => (state.token = null),
          'error-callback': () => {
            state.token = null;
            state.waiters.splice(0).forEach((resolve) => resolve(''));
          },
        });
      };
      if (window.turnstile) return render();
      (window.evenliTurnstileQueue = window.evenliTurnstileQueue || []).push(render);
      if (document.querySelector('script[data-turnstile-api]')) return;
      window.evenliTurnstileReady = () => window.evenliTurnstileQueue.splice(0).forEach((fn) => fn());
      const script = document.createElement('script');
      script.src = 'https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit&onload=evenliTurnstileReady';
      script.async = true;
      script.dataset.turnstileApi = '';
      document.head.appendChild(script);
    }

    /* Resolves with the token, or '' when Turnstile is off or does not answer
       within 10 s (the worker then decides). */
    turnstileToken(form) {
      if (!this.dataset.turnstileKey || !form.querySelector('[data-quiz-turnstile]')) return Promise.resolve('');
      this.turnstile(form);
      const state = form.turnstileState;
      if (state.token) return Promise.resolve(state.token);
      return new Promise((resolve) => {
        state.waiters.push(resolve);
        setTimeout(() => resolve(''), 10000);
      });
    }

    /* A token is single use: after any attempt she needs a fresh one. */
    resetTurnstile(form) {
      const state = form.turnstileState;
      if (!state || state.id === null || !window.turnstile) return;
      state.token = null;
      window.turnstile.reset(state.id);
    }

    /* After the sign-up the card opens. Shared mode: the code and the link
       that applies it in the cart. Personal mode: a countdown from the moment
       of the sign-up, which is when the Flow dated her code. */
    unlock(result, status) {
      if (!result) return;
      const card = result.querySelector('[data-quiz-code-card]');
      const code = (this.dataset.code || '').trim();
      if (!card) return;
      card.classList.add('is-unlocked');
      if (card.dataset.mode === 'personal') {
        this.personal(card, result);
        return;
      }
      if (code) {
        card.querySelectorAll('[data-quiz-mirror="code"]').forEach((el) => (el.textContent = code));
        this.armCode(card, result, code);
      }
      if (!code) this.setStatus(status, this.t.email.success, 'success');
    }

    /* Personal mode: the worker issued her single-use code with the sign-up
       (one per address); show it and count down to the end time Shopify set.
       The pair is kept in storage so a reload shows the same code. Without
       one, fall back to the shared code so the promise on the card is kept. */
    personal(card, result) {
      let saved = null;
      try {
        saved = JSON.parse(localStorage.getItem(QUIZ_STORE + ':code') || 'null');
      } catch (e) {
        saved = null;
      }
      saved = saved || this.issued;
      if (saved && saved.code && saved.endsAt && new Date(saved.endsAt) > new Date()) {
        return this.showPersonal(card, result, saved);
      }
      // No personal code (worker off, or her one code has run out): the
      // shared code, without a timer.
      const code = (this.dataset.code || '').trim();
      if (code) this.showPersonal(card, result, { code, endsAt: null });
    }

    /* The open card is a tap target: the tap attaches the code to her cart
       through Shopify's own discount link, in the background, and the strip
       on the card confirms it. She stays on the result page, where the
       add-to-cart is. If the background call fails, the tap falls back to
       following the link. */
    armCode(card, result, code) {
      card.dataset.code = code;
      const redirect = result.dataset.productUrl || this.dataset.compare || '/';
      const link = card.querySelector('[data-quiz-code-link]');
      if (link) link.href = '/discount/' + encodeURIComponent(code) + '?redirect=' + encodeURIComponent(redirect);
      card.classList.add('is-armed');
      // The card's own add-to-cart now carries the code too.
      const addForm = result.querySelector('.article-product__form');
      if (addForm && !addForm.dataset.quizBound) {
        addForm.dataset.quizBound = '1';
        // The button opens the quick-buy window, so no submit fires; the code
        // goes onto the cart as the window opens, ready for what she adds.
        addForm.addEventListener('click', (event) => {
          if (!card.classList.contains('is-armed') || !event.target.closest('[data-quick-buy]')) return;
          if (!window.fetch) return;
          fetch('/cart/update.js', {
            method: 'POST',
            credentials: 'same-origin',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ discount: card.dataset.code }),
          })
            .then(() => this.track('quiz_code_applied', {}))
            .catch(() => {});
        });
        addForm.addEventListener(
          'submit',
          (event) => {
            if (!card.classList.contains('is-armed')) return;
            event.preventDefault();
            event.stopImmediatePropagation();
            this.applyCode(card, result);
          },
          true,
        );
      }
    }

    /* Puts the chosen pack in the cart, attaches the code to the cart itself
       (cart/update.js with `discount`, the Cart API's own field), then opens
       the drawer with the product and the saving on it. */
    applyCode(card, result) {
      const code = card.dataset.code;
      const addForm = result.querySelector('.article-product__form');
      if (!code || !addForm) return;
      const button = addForm.querySelector('[type="submit"]');
      const fallback =
        '/discount/' +
        encodeURIComponent(code) +
        '?redirect=' +
        encodeURIComponent(result.dataset.productUrl || '/cart');
      if (!window.fetch) {
        window.location.href = fallback;
        return;
      }
      if (button) button.disabled = true;
      const body = new FormData(addForm);
      const drawer = document.querySelector('cart-drawer');
      fetch('/cart/add.js', {
        method: 'POST',
        body,
        credentials: 'same-origin',
        headers: { Accept: 'application/json' },
      })
        .then((r) => (r.ok ? r.json() : Promise.reject(new Error('add ' + r.status))))
        .then(() =>
          fetch('/cart/update.js', {
            method: 'POST',
            credentials: 'same-origin',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ discount: code }),
          }),
        )
        .then((r) => (r.ok ? r.json() : Promise.reject(new Error('update ' + r.status))))
        .then((cart) => {
          if (button) button.disabled = false;
          card.classList.add('is-applied');
          const done = card.querySelector('[data-quiz-code-done]');
          if (done) done.hidden = false;
          this.track('quiz_code_applied', {});
          document.dispatchEvent(new CustomEvent('cart:updated', { detail: { count: cart.item_count } }));
          if (!drawer) {
            window.location.href = '/cart';
            return;
          }
          const after = typeof drawer.refresh === 'function' ? drawer.refresh() : Promise.resolve();
          Promise.resolve(after).then(() => {
            if (typeof drawer.open === 'function') drawer.open(button);
          });
        })
        .catch(() => {
          if (button) button.disabled = false;
          window.location.href = fallback;
        });
    }

    showPersonal(card, result, data) {
      const value = card.querySelector('[data-quiz-code-value]');
      if (value) value.textContent = data.code;
      card.querySelectorAll('[data-quiz-mirror="code"]').forEach((el) => (el.textContent = data.code));
      this.armCode(card, result, data.code);
      const timerWrap = card.querySelector('[data-quiz-countdown-wrap]');
      if (!data.endsAt) {
        if (timerWrap) timerWrap.hidden = true;
        return;
      }
      if (timerWrap) timerWrap.hidden = false;
      this.countdown(card, new Date(data.endsAt).getTime());
    }

    /* Counts down to `until`, the real end of the code. */
    countdown(card, until) {
      const out = card.querySelector('[data-quiz-countdown]');
      const text = card.querySelector('[data-quiz-countdown-text]');
      const expired = card.querySelector('[data-quiz-countdown-expired]');
      const pad = (n) => String(n).padStart(2, '0');
      const tick = () => {
        const left = until - Date.now();
        if (left <= 0) {
          if (out) out.hidden = true;
          if (text) text.hidden = true;
          if (expired) expired.hidden = false;
          const value = card.querySelector('[data-quiz-code-value]');
          if (value) value.hidden = true;
          card.classList.remove('is-armed');
          try {
            localStorage.removeItem(QUIZ_STORE + ':code');
          } catch (e) {
            /* fine */
          }
          return;
        }
        const h = Math.floor(left / 3600000);
        const m = Math.floor((left % 3600000) / 60000);
        const s = Math.floor((left % 60000) / 1000);
        const stamp = pad(h) + ':' + pad(m) + ':' + pad(s);
        if (out) out.textContent = stamp;
        card.querySelectorAll('[data-quiz-mirror="time"]').forEach((el) => (el.textContent = stamp));
        this.timer = setTimeout(tick, 1000);
      };
      clearTimeout(this.timer);
      tick();
    }

    setStatus(el, text, kind) {
      if (!el) return;
      el.textContent = text || '';
      el.className = 'quiz__email-status is-' + kind;
      el.hidden = !text;
    }

    /* ---- analytics ---- */

    /* Funnel events for analytics: which step happened, never what was
       answered or recommended. Anything sent here can reach ad pixels, and
       quiz answers are health data — the practice Hims & Hers were sued for
       (FTC, 2026). Keep every detail free of answers and results. */
    track(name, detail) {
      document.dispatchEvent(new CustomEvent(name, { detail, bubbles: true }));
      if (Array.isArray(window.dataLayer)) window.dataLayer.push(Object.assign({ event: name }, detail));
      try {
        if (window.Shopify && window.Shopify.analytics && window.Shopify.analytics.publish) {
          window.Shopify.analytics.publish(name, detail);
        }
      } catch (e) {
        /* analytics must never break the quiz */
      }
    }
  }

  if (!customElements.get('product-quiz')) {
    customElements.define('product-quiz', ProductQuiz);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-reviews"] && !Shopify.designMode) return;
  try {
    
  class ProductReviews extends HTMLElement {
    connectedCallback() {
      if (this.initialised) return;
      this.initialised = true;

      this.list = this.querySelector('[data-prev-list]');
      this.items = Array.from(this.querySelectorAll('[data-prev-review]'));
      this.empty = this.querySelector('[data-prev-empty]');
      this.search = this.querySelector('[data-prev-search]');
      this.sort = this.querySelector('[data-prev-sort]');
      this.rating = this.querySelector('[data-prev-rating]');
      this.photos = this.querySelector('[data-prev-photos]');
      this.reset = this.querySelector('[data-prev-reset]');
      this.foot = this.querySelector('[data-prev-foot]');
      this.more = this.querySelector('[data-prev-more]');

      // Nothing to drive: the section rendered without the control row.
      if (!this.list || !this.items.length) return;

      this.limit = Number(this.list.dataset.prevLimit) || 0;
      this.expanded = false;

      ['input', 'change'].forEach((type) => this.addEventListener(type, () => this.apply()));
      if (this.reset) this.reset.addEventListener('click', () => this.clear());
      if (this.more) {
        this.more.addEventListener('click', () => {
          this.expanded = true;
          this.apply();
        });
      }

      this.strip = this.querySelector('[data-prev-strip]');
      if (this.strip) this.enableDrag(this.strip);

      this.apply();
    }

    /* Click-and-drag panning for a mouse. Two things make it feel right:
       scroll-snap is suspended for the duration (otherwise the browser fights
       every frame of the drag, trying to settle on a card while the pointer is
       still moving), and the release carries the pointer's velocity into an
       inertial glide instead of stopping dead. Snap comes back once the glide
       settles, so the rail still parks neatly on a card. */
    enableDrag(rail) {
      const FRICTION = 0.94;
      const MIN_VELOCITY = 0.04;
      const DRAG_THRESHOLD = 4;

      let startX = 0;
      let startLeft = 0;
      let lastX = 0;
      let lastTime = 0;
      let velocity = 0;
      let pressed = false;
      let frame = null;
      this.stripDragged = false;

      const stopGlide = () => {
        if (frame === null) return;
        cancelAnimationFrame(frame);
        frame = null;
      };

      const settle = () => {
        rail.classList.remove('is-dragging');
      };

      const glide = () => {
        const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        // px/ms at 60fps -> px per frame.
        let speed = reduced ? 0 : velocity * 16;
        if (Math.abs(speed) < MIN_VELOCITY * 16) return settle();

        const step = () => {
          speed *= FRICTION;
          rail.scrollLeft -= speed;

          const atStart = rail.scrollLeft <= 0;
          const atEnd = rail.scrollLeft >= rail.scrollWidth - rail.clientWidth - 1;
          if (Math.abs(speed) < 0.4 || atStart || atEnd) {
            frame = null;
            return settle();
          }
          frame = requestAnimationFrame(step);
        };
        frame = requestAnimationFrame(step);
      };

      rail.addEventListener('pointerdown', (event) => {
        if (event.pointerType !== 'mouse' || event.button !== 0) return;
        stopGlide();
        pressed = true;
        this.stripDragged = false;
        startX = event.clientX;
        lastX = event.clientX;
        startLeft = rail.scrollLeft;
        lastTime = event.timeStamp;
        velocity = 0;
        /* Capture is deliberately not taken here — a captured pointer makes
           the browser dispatch the resulting `click` at the capturing element,
           so anything clickable inside the strip would stop receiving clicks.
           It is taken below, once this is a drag rather than a click. */
      });

      rail.addEventListener('pointermove', (event) => {
        if (!pressed) return;
        const moved = event.clientX - startX;

        // Below the threshold this is still a click, not a drag.
        if (!this.stripDragged) {
          if (Math.abs(moved) < DRAG_THRESHOLD) return;
          this.stripDragged = true;
          rail.classList.add('is-dragging');
          // Now it is a drag: keep tracking even if the pointer leaves.
          if (rail.setPointerCapture) rail.setPointerCapture(event.pointerId);
        }

        event.preventDefault();

        // Past an edge the strip follows less and less, instead of stopping dead.
        const wanted = startLeft - moved;
        const max = Math.max(0, rail.scrollWidth - rail.clientWidth);
        const band = (overshoot) =>
          (overshoot * rail.clientWidth * 0.55) / (rail.clientWidth + 0.55 * Math.abs(overshoot));
        if (wanted < 0) rail.scrollLeft = -band(-wanted);
        else if (wanted > max) rail.scrollLeft = max + band(wanted - max);
        else rail.scrollLeft = wanted;

        const elapsed = event.timeStamp - lastTime;
        if (elapsed > 0) {
          // Blend with the previous reading so one jittery frame near the end
          // of a drag cannot decide the whole throw.
          const sample = (event.clientX - lastX) / elapsed;
          velocity = velocity * 0.2 + sample * 0.8;
          lastX = event.clientX;
          lastTime = event.timeStamp;
        }
      });

      const release = (event) => {
        if (!pressed) return;
        pressed = false;
        if (rail.hasPointerCapture && rail.hasPointerCapture(event.pointerId)) {
          rail.releasePointerCapture(event.pointerId);
        }
        if (!this.stripDragged) return settle();
        glide();
      };

      rail.addEventListener('pointerup', release);
      rail.addEventListener('pointercancel', release);

      // A drag that ends over a card must not also open it.
      rail.addEventListener(
        'click',
        (event) => {
          if (!this.stripDragged) return;
          event.preventDefault();
          event.stopPropagation();
        },
        true,
      );
    }

    clear() {
      if (this.search) this.search.value = '';
      if (this.sort) this.sort.value = 'featured';
      if (this.rating) this.rating.value = 'all';
      if (this.photos) this.photos.checked = false;
      this.apply();
    }

    apply() {
      const query = this.search ? this.search.value.trim().toLowerCase() : '';
      const wanted = this.rating ? this.rating.value : 'all';
      const photosOnly = this.photos ? this.photos.checked : false;

      let shown = 0;
      this.items.forEach((item) => {
        const matchesQuery = !query || item.dataset.text.includes(query);
        const matchesRating = wanted === 'all' || item.dataset.rating === wanted;
        const matchesPhoto = !photosOnly || item.dataset.photo === 'true';
        const visible = matchesQuery && matchesRating && matchesPhoto;

        // Matching and being on screen are two different things once the list
        // is capped, so which one it was is recorded for cap() to read.
        item.dataset.matched = visible ? 'true' : 'false';
        item.hidden = !visible;
        if (visible) shown += 1;
      });

      if (this.empty) this.empty.hidden = shown > 0;

      this.order();
      this.cap(shown);
    }

    /* Hides everything past the limit. It runs after order(), because the cap
       has to fall on the list as it is actually read — sorting by highest
       first and then keeping "the first four" has to mean the four now at the
       top, not the four the merchant happened to enter first. */
    cap(matched) {
      if (!this.limit || !this.more) return;

      if (!this.expanded) {
        let seen = 0;
        Array.from(this.list.children).forEach((item) => {
          if (item.dataset.matched !== 'true') return;
          seen += 1;
          if (seen > this.limit) item.hidden = true;
        });
      }

      // Filtering down to four leaves nothing to expand, so the button goes.
      this.more.hidden = this.expanded || matched <= this.limit;
      if (this.foot) this.foot.hidden = this.more.hidden && !this.foot.querySelector('.prev__foot-note');
    }

    order() {
      const mode = this.sort ? this.sort.value : 'featured';
      const by = {
        // Merchant block order is the curated order, so it is the default.
        featured: (a, b) => Number(a.dataset.order) - Number(b.dataset.order),
        highest: (a, b) => Number(b.dataset.rating) - Number(a.dataset.rating),
        lowest: (a, b) => Number(a.dataset.rating) - Number(b.dataset.rating),
      };
      const compare = by[mode] || by.featured;

      // Equal ratings keep their curated order rather than shuffling.
      const sorted = this.items
        .slice()
        .sort((a, b) => compare(a, b) || Number(a.dataset.order) - Number(b.dataset.order));

      const fragment = document.createDocumentFragment();
      sorted.forEach((item) => fragment.appendChild(item));
      this.list.appendChild(fragment);
    }
  }

  if (!customElements.get('product-reviews')) {
    customElements.define('product-reviews', ProductReviews);
  }

  /* "Bewertung schreiben" → scroll to the Judge.me widget and open its form.
     Judge.me renders the widget after load, so its own write button is
     looked up on click, not at start-up; without it the link still scrolls. */
  document.addEventListener(
    'click',
    function (event) {
      var link = event.target.closest && event.target.closest('[data-review-write]');
      if (!link || link.getAttribute('href') !== '#reviews-app') return;
      var widget = document.getElementById('reviews-app');
      if (!widget) return;
      event.preventDefault();
      var open = Array.from(widget.querySelectorAll('button, a')).find(function (el) {
        return /bewertung schreiben|write a review/i.test(el.textContent || '');
      });
      if (open) {
        // Opened after this click has finished: Judge.me closes its window on
        // any click outside it, and this very click is outside it.
        event.stopPropagation();
        setTimeout(function () {
          open.click();
        }, 0);
      } else {
        widget.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
      // Capture phase, so this runs before any other click handler.
    },
    true,
  );

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-testimonials"] && !Shopify.designMode) return;
  try {
    
  /* Motion model follows Apple's "Designing Fluid Interfaces": the drag tracks
     1:1, the release projects where the throw was going, and a critically
     damped spring carries the pointer's velocity into the settle. Every
     animation runs on rAF from the live scroll position, so a new grab
     interrupts it mid-flight instead of queueing behind it. */
  class TestimonialRail extends HTMLElement {
    connectedCallback() {
      if (this.initialised) return;
      this.initialised = true;

      this.rail = this.querySelector('[data-trail-rail]');
      this.prev = this.querySelector('[data-trail-prev]');
      this.next = this.querySelector('[data-trail-next]');
      this.thumb = this.querySelector('[data-trail-thumb]');
      if (!this.rail) return;

      this.cards = Array.from(this.rail.children);
      this.frame = null;
      this.pressed = false;
      this.dragged = false;

      this.addEventListener('click', this.onClick.bind(this));
      this.enableDrag();

      this.rail.addEventListener(
        'scroll',
        () => {
          this.sync();
          // Trackpad and touch scrolling has no release event to hook, so the
          // settle for those is debounced off the last scroll frame. A mouse
          // drag settles from its own release and never reaches this.
          if (this.pressed || this.frame !== null) return;
          clearTimeout(this.settleTimer);
          this.settleTimer = setTimeout(() => this.settle(0), 120);
        },
        { passive: true },
      );

      this.observer = new ResizeObserver(() => {
        this.sync();
        this.settle(0, true);
      });
      this.observer.observe(this.rail);
      this.sync();
    }

    disconnectedCallback() {
      if (this.observer) this.observer.disconnect();
      clearTimeout(this.settleTimer);
      this.stop();
    }

    get reduced() {
      return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    }

    get maxScroll() {
      return Math.max(0, this.rail.scrollWidth - this.rail.clientWidth);
    }

    /* Where each card starts, in scroll coordinates. Measured rather than
       accumulated from widths, so the rail's inline padding and any sub-pixel
       gap are already accounted for at every breakpoint. */
    offsets() {
      const railBox = this.rail.getBoundingClientRect();
      const pad = parseFloat(getComputedStyle(this.rail).paddingInlineStart) || 0;
      return this.cards.map((card) =>
        Math.round(this.rail.scrollLeft + card.getBoundingClientRect().left - railBox.left - pad),
      );
    }

    /* Apple's projection function: where a throw at this velocity would come to
       rest. Used to pick the destination card, so a flick throws the rail
       instead of nudging it to whatever happened to be nearest on release. */
    project(velocity, decelerationRate = 0.998) {
      return ((velocity / 1000) * decelerationRate) / (1 - decelerationRate);
    }

    nearest(position) {
      const offsets = this.offsets();
      if (!offsets.length) return null;
      const max = this.maxScroll;
      const target = offsets.reduce(
        (best, offset) => (Math.abs(offset - position) < Math.abs(best - position) ? offset : best),
        offsets[0],
      );
      return Math.max(0, Math.min(target, max));
    }

    /* velocity is px/s in scroll space. */
    settle(velocity, immediate) {
      const current = this.rail.scrollLeft;
      const max = this.maxScroll;
      // Both ends are already flush; pulling the last card off the edge to
      // align the one before it would look worse, not better.
      if (max <= 0) return;
      if (current <= 1 && velocity <= 0) return;
      if (current >= max - 1 && velocity >= 0) return;

      const target = this.nearest(current + this.project(velocity));
      if (target === null) return;

      if (immediate || this.reduced) {
        this.stop();
        this.rail.scrollLeft = target;
        return;
      }
      if (Math.abs(target - current) < 1 && Math.abs(velocity) < 40) return;
      this.spring(target, velocity);
    }

    stop() {
      if (this.frame === null) return;
      cancelAnimationFrame(this.frame);
      this.frame = null;
    }

    /* Critically damped by default (damping 1.0, response 0.42) so it lands
       without wobble; the release velocity is handed straight in, which is what
       removes the seam between dragging and animating. */
    spring(target, velocity) {
      this.stop();

      const response = 0.42;
      const damping = 1;
      const stiffness = ((2 * Math.PI) / response) ** 2;
      const damper = (4 * Math.PI * damping) / response;

      let position = this.rail.scrollLeft;
      let speed = velocity;
      let last = null;

      const step = (now) => {
        if (last === null) last = now;
        // Clamp dt so a backgrounded tab does not integrate one huge step.
        const dt = Math.min((now - last) / 1000, 1 / 30);
        last = now;

        speed += (-stiffness * (position - target) - damper * speed) * dt;
        position += speed * dt;

        if (Math.abs(position - target) < 0.5 && Math.abs(speed) < 25) {
          this.rail.scrollLeft = target;
          this.frame = null;
          this.sync();
          return;
        }

        this.rail.scrollLeft = position;
        this.frame = requestAnimationFrame(step);
      };

      this.frame = requestAnimationFrame(step);
    }

    onClick(event) {
      const play = event.target.closest('[data-trail-play]');
      if (play) return this.playVideo(play);

      if (event.target.closest('[data-trail-prev]')) return this.step(-1);
      if (event.target.closest('[data-trail-next]')) return this.step(1);
    }

    /* Arrows move card to card, always landing on an edge. */
    step(direction) {
      const offsets = this.offsets();
      if (!offsets.length) return;

      const current = this.rail.scrollLeft;
      const max = this.maxScroll;
      let target =
        direction > 0
          ? offsets.find((offset) => offset > current + 2)
          : offsets
              .slice()
              .reverse()
              .find((offset) => offset < current - 2);

      if (target === undefined) target = direction > 0 ? max : 0;
      target = Math.max(0, Math.min(target, max));

      clearTimeout(this.settleTimer);
      if (this.reduced) {
        this.stop();
        this.rail.scrollLeft = target;
        this.sync();
        return;
      }
      this.spring(target, 0);
    }

    playVideo(button) {
      const video = button.parentElement.querySelector('video');
      if (!video) return;

      // Only one clip plays at a time — a rail of talking heads over each other
      // is the failure mode of this pattern.
      this.querySelectorAll('video').forEach((other) => {
        if (other === video) return;
        other.pause();
        other.parentElement.classList.remove('is-playing');
        const otherButton = other.parentElement.querySelector('[data-trail-play]');
        if (otherButton) otherButton.hidden = false;
      });

      const media = button.parentElement;
      media.classList.add('is-playing');
      video.controls = true;
      button.hidden = true;

      const started = video.play();
      // Autoplay policies can reject; put the affordance back rather than
      // leaving a video that looks broken.
      if (started && typeof started.catch === 'function') {
        started.catch(() => {
          button.hidden = false;
          video.controls = false;
          media.classList.remove('is-playing');
        });
      }
      video.addEventListener(
        'pause',
        () => {
          button.hidden = false;
          media.classList.remove('is-playing');
        },
        { once: true },
      );
    }

    enableDrag() {
      const rail = this.rail;
      const DRAG_THRESHOLD = 4;
      const RUBBER = 0.55;

      let startX = 0;
      let startLeft = 0;
      let lastX = 0;
      let lastTime = 0;
      let velocity = 0;

      // Past an edge the rail follows less and less, instead of stopping dead.
      const rubberband = (overshoot, dimension) =>
        (overshoot * dimension * RUBBER) / (dimension + RUBBER * Math.abs(overshoot));

      rail.addEventListener('pointerdown', (event) => {
        if (event.pointerType !== 'mouse' || event.button !== 0) return;
        // Grabbing mid-flight takes over from the current position.
        this.stop();
        clearTimeout(this.settleTimer);

        this.pressed = true;
        this.dragged = false;
        startX = event.clientX;
        lastX = event.clientX;
        startLeft = rail.scrollLeft;
        lastTime = event.timeStamp;
        velocity = 0;
        /* Capture is deliberately NOT taken here. A captured pointer makes the
           browser dispatch the resulting `click` at the capturing element, so
           every click inside the rail — the play button included — would arrive
           targeting the rail itself and never reach the control. Capture is
           taken below, the moment this becomes a drag rather than a click. */
      });

      rail.addEventListener('pointermove', (event) => {
        if (!this.pressed) return;
        const moved = event.clientX - startX;

        // Below the threshold this is still a click, not a drag.
        if (!this.dragged) {
          if (Math.abs(moved) < DRAG_THRESHOLD) return;
          this.dragged = true;
          rail.classList.add('is-dragging');
          // Now it is a drag: keep tracking even if the pointer leaves the rail.
          if (rail.setPointerCapture) rail.setPointerCapture(event.pointerId);
        }

        event.preventDefault();

        const wanted = startLeft - moved;
        const max = this.maxScroll;
        if (wanted < 0) {
          rail.scrollLeft = -rubberband(-wanted, rail.clientWidth);
        } else if (wanted > max) {
          rail.scrollLeft = max + rubberband(wanted - max, rail.clientWidth);
        } else {
          rail.scrollLeft = wanted;
        }

        const elapsed = event.timeStamp - lastTime;
        if (elapsed > 0) {
          // Blended with the previous reading so one jittery frame at the end
          // of a drag cannot decide the whole throw.
          const sample = (event.clientX - lastX) / elapsed;
          velocity = velocity * 0.2 + sample * 0.8;
          lastX = event.clientX;
          lastTime = event.timeStamp;
        }
      });

      const release = (event) => {
        if (!this.pressed) return;
        this.pressed = false;
        if (rail.hasPointerCapture && rail.hasPointerCapture(event.pointerId)) {
          rail.releasePointerCapture(event.pointerId);
        }
        rail.classList.remove('is-dragging');
        if (!this.dragged) return;

        // Pointer velocity is px/ms and points the opposite way to scroll.
        const stale = event.timeStamp - lastTime > 90;
        this.settle(stale ? 0 : -velocity * 1000);
      };

      rail.addEventListener('pointerup', release);
      rail.addEventListener('pointercancel', release);

      // A drag that ends over a card must not also open it.
      rail.addEventListener(
        'click',
        (event) => {
          if (!this.dragged) return;
          event.preventDefault();
          event.stopPropagation();
        },
        true,
      );
    }

    sync() {
      const max = this.maxScroll;
      const at = this.rail.scrollLeft;
      // 1px of slack: fractional scroll positions never land exactly on the end.
      if (this.prev) this.prev.disabled = at <= 1;
      if (this.next) this.next.disabled = at >= max - 1;

      if (this.thumb) {
        const total = this.rail.scrollWidth || 1;
        const share = Math.min(1, this.rail.clientWidth / total);
        const progress = max > 0 ? Math.min(1, Math.max(0, at / max)) : 0;
        // Width is the visible share; the offset runs it from start to end
        // of the track as the rail scrolls from first card to last.
        this.thumb.style.width = share * 100 + '%';
        this.thumb.style.transform = 'translateX(' + progress * ((1 - share) / share) * 100 + '%)';
      }
    }
  }

  if (!customElements.get('testimonial-rail')) {
    customElements.define('testimonial-rail', TestimonialRail);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
  // Delivery promise as a date: today plus 4 working days (the end of the
  // "2–4 Werktage" range), weekends skipped, in the page's language.
  (function () {
    document.querySelectorAll('[data-pdp-delivery]').forEach(function (el) {
      var date = new Date();
      var added = 0;
      while (added < 4) {
        date.setDate(date.getDate() + 1);
        if (date.getDay() !== 0 && date.getDay() !== 6) added++;
      }
      var label = new Intl.DateTimeFormat(document.documentElement.lang || 'de', {
        weekday: 'short',
        day: 'numeric',
        month: 'short',
      }).format(date);
      el.textContent = el.dataset.template.replace('%DATE%', label);
    });
  })();

  (function () {
    function init() {
      var root = document.querySelector('.pdp');
      if (!root) return;

      /* ---------- Mobile gallery rail ----------
         The track is the mosaic itself, restyled by CSS below 40rem, so there is
         one set of images rather than a second carousel. This only keeps the
         rail and the track pointing at each other. */
      var track = root.querySelector('.pdp__mosaic');
      var thumbs = Array.prototype.slice.call(root.querySelectorAll('[data-pdp-goto]'));

      if (track && thumbs.length) {
        var tiles = Array.prototype.slice.call(track.querySelectorAll('.pdp__tile'));

        var setActive = function (i) {
          thumbs.forEach(function (t, n) {
            t.classList.toggle('is-active', n === i);
          });
          var active = thumbs[i];
          if (!active || !active.parentNode) return;
          // Keep the selected thumbnail in view without scrolling the page.
          var rail = active.parentNode;
          var left = active.offsetLeft - rail.clientWidth / 2 + active.clientWidth / 2;
          rail.scrollTo({ left: left, behavior: 'smooth' });
        };

        // Slides are narrower than the track, so "which slide is showing" is the
        // one whose centre is nearest the track's centre — not scrollLeft over
        // clientWidth, which is only true when a slide fills the viewport.
        var centreOf = function (tile) {
          return tile.offsetLeft + tile.offsetWidth / 2;
        };

        var nearest = function () {
          var mid = track.scrollLeft + track.clientWidth / 2;
          var best = 0;
          var bestDist = Infinity;
          tiles.forEach(function (tile, n) {
            var d = Math.abs(centreOf(tile) - mid);
            if (d < bestDist) {
              bestDist = d;
              best = n;
            }
          });
          return best;
        };

        thumbs.forEach(function (t, i) {
          t.addEventListener('click', function () {
            var tile = tiles[i];
            if (tile) {
              track.scrollTo({
                left: centreOf(tile) - track.clientWidth / 2,
                behavior: 'smooth',
              });
            }
            setActive(i);
          });
        });

        // Rail follows a swipe. rAF-throttled: scroll fires far more often than
        // the class actually needs to change.
        var ticking = false;
        track.addEventListener(
          'scroll',
          function () {
            if (ticking) return;
            ticking = true;
            requestAnimationFrame(function () {
              ticking = false;
              var i = nearest();
              if (thumbs[i] && !thumbs[i].classList.contains('is-active')) setActive(i);
            });
          },
          { passive: true },
        );
      }

      /* ---------- Lightbox ---------- */
      var lb = root.querySelector('.pdp__lb');
      if (lb) {
        var lbImg = lb.querySelector('[data-pdp-lb-img]');
        var lbThumbs = Array.prototype.slice.call(lb.querySelectorAll('[data-pdp-lb-thumb]'));
        var lbOpener = null;
        var lbTimer;

        function lbShow(i) {
          var t = lbThumbs[i];
          if (!t || !lbImg) return;
          lbImg.src = t.getAttribute('data-src');
          lbImg.alt = t.getAttribute('data-alt') || '';
          lbThumbs.forEach(function (x) {
            x.classList.toggle('is-active', x === t);
          });
        }

        function lbOpen(i, trigger) {
          lbOpener = trigger || null;

          /* Anchor the growth to the tile that was clicked, so the panel comes
             from where the reader looked rather than from nowhere. */
          var card = lb.querySelector('.pdp__lb-card');
          if (card && trigger && trigger.getBoundingClientRect) {
            var r = trigger.getBoundingClientRect();
            card.style.setProperty('--pdp-lb-x', (((r.left + r.width / 2) / window.innerWidth) * 100).toFixed(1) + '%');
            card.style.setProperty(
              '--pdp-lb-y',
              (((r.top + r.height / 2) / window.innerHeight) * 100).toFixed(1) + '%',
            );
          }

          lbShow(i);
          lb.hidden = false;
          document.body.style.overflow = 'hidden';
          requestAnimationFrame(function () {
            requestAnimationFrame(function () {
              lb.classList.add('is-open');
            });
          });
          var closeBtn = lb.querySelector('.pdp__lb-close');
          if (closeBtn) closeBtn.focus({ preventScroll: true });
        }

        function lbClose() {
          if (lb.hidden) return;
          lb.classList.remove('is-open');
          var done = function () {
            lb.hidden = true;
            document.body.style.overflow = '';
            clearTimeout(lbTimer);
          };
          var card = lb.querySelector('.pdp__lb-card');
          if (card) card.addEventListener('transitionend', done, { once: true });
          lbTimer = setTimeout(done, 400);
          if (lbOpener && document.contains(lbOpener)) lbOpener.focus({ preventScroll: true });
        }

        root.querySelectorAll('[data-pdp-open]').forEach(function (tile) {
          tile.addEventListener('click', function () {
            lbOpen(parseInt(tile.getAttribute('data-pdp-open'), 10), tile);
          });
        });
        lbThumbs.forEach(function (t, i) {
          t.addEventListener('click', function () {
            lbShow(i);
          });
        });
        lb.querySelectorAll('[data-pdp-lb-close]').forEach(function (el) {
          el.addEventListener('click', lbClose);
        });

        document.addEventListener('keydown', function (e) {
          if (lb.hidden) return;
          if (e.key === 'Escape') return lbClose();

          var current = lbThumbs.findIndex(function (x) {
            return x.classList.contains('is-active');
          });
          if (e.key === 'ArrowRight') lbShow((current + 1) % lbThumbs.length);
          else if (e.key === 'ArrowLeft') lbShow((current - 1 + lbThumbs.length) % lbThumbs.length);
          else if (e.key === 'Tab') {
            /* Keep focus inside the dialog — a modal that lets Tab wander behind
               the scrim strands keyboard users with no way back. */
            var f = lb.querySelectorAll('button:not([disabled])');
            if (!f.length) return;
            var first = f[0],
              last = f[f.length - 1];
            if (e.shiftKey && document.activeElement === first) {
              e.preventDefault();
              last.focus();
            } else if (!e.shiftKey && document.activeElement === last) {
              e.preventDefault();
              first.focus();
            }
          }
        });
      }

      /* ---------- Purchase options ----------

         Two independent choices multiply together: which pack size, and whether
         it is a one-off or a subscription. Both have to drive the same set of
         prices, so there is one `render()` that reads the current state and
         writes every price on screen, rather than each control patching the
         labels it happens to know about.

         All money is formatted by Liquid and carried in the data island — the
         shop's own `money` filter, so German grouping and the currency position
         are right without reimplementing them here. */
      var hidden = root.querySelector('[data-pdp-selling-plan]');
      var submitPrice = root.querySelector('[data-pdp-price]');
      var oneTimePrice = root.querySelector('[data-pdp-onetime-price]');
      var variantIdInput = root.querySelector('[data-pdp-variant-id]');
      var submitBtn = root.querySelector('.pdp__submit');

      var savingLabel = root.getAttribute('data-pdp-saving-label') || '';
      var savePercentLabel = root.getAttribute('data-pdp-save-label') || '';
      /* Read once here rather than inside `render()`: the per-day phrasing is
         a translated template, and both the size cards and the sticky bar
         fill it in. */
      var sizesField = root.querySelector('[data-pdp-day-label]');
      var dayLabel = sizesField ? sizesField.getAttribute('data-pdp-day-label') || '' : '';
      var variants = [];
      var dataEl = root.querySelector('[data-pdp-variants]');
      if (dataEl) {
        try {
          variants = JSON.parse(dataEl.textContent) || [];
        } catch (e) {
          variants = [];
        }
      }

      function selectedOptions() {
        return Array.prototype.slice.call(root.querySelectorAll('[data-pdp-option]:checked')).map(function (input) {
          return input.value;
        });
      }

      function currentVariant() {
        var chosen = selectedOptions();
        if (!variants.length) return null;
        if (!chosen.length) return variants[0];
        for (var i = 0; i < variants.length; i++) {
          var v = variants[i];
          if (!v.options || v.options.length !== chosen.length) continue;
          var all = true;
          for (var j = 0; j < chosen.length; j++) {
            if (v.options[j] !== chosen[j]) {
              all = false;
              break;
            }
          }
          if (all) return v;
        }
        return null;
      }

      /* Each pack size has exactly one subscription plan, so there is nothing
         to pick — the plan follows the size. */
      function chosenPlanId() {
        var picked = root.querySelector('[data-pdp-choice]:checked');
        if (!picked || picked.value !== 'sub') return null;
        var v = currentVariant();
        if (!v || !v.plans) return null;
        var ids = Object.keys(v.plans);
        return ids.length ? ids[0] : null;
      }

      function setText(selector, value) {
        var el = root.querySelector(selector);
        if (el && value != null) el.textContent = value;
      }

      function render() {
        var v = currentVariant();
        var planId = chosenPlanId();
        var plan = v && planId && v.plans ? v.plans[planId] : null;

        if (hidden) hidden.value = planId || '';

        // A size that does not exist as a variant must not be submittable.
        if (submitBtn) {
          var buyable = !!(v && v.available);
          submitBtn.disabled = !buyable;
          submitBtn.classList.toggle('is-unavailable', !buyable);
        }

        if (!v) return;

        if (variantIdInput) variantIdInput.value = v.id;

        // Reflect the choice in the URL so a reload or a shared link keeps it.
        if (window.history && window.history.replaceState) {
          var url = new URL(window.location.href);
          url.searchParams.set('variant', v.id);
          window.history.replaceState({}, '', url);
        }

        // One-time card always shows this variant's own price.
        if (oneTimePrice) oneTimePrice.textContent = v.priceText;
        if (v.hasPerServing) setText('[data-pdp-onetime-unit]', v.perServingText);

        // Subscription card follows the same variant.
        if (plan) {
          setText('[data-pdp-sub-price]', plan.priceText);
          setText('[data-pdp-sub-was]', plan.wasText);
          setText('[data-pdp-sub-unit]', plan.perServingText);

          var badge = root.querySelector('[data-pdp-badge]');
          var perk = root.querySelector('[data-pdp-perk-percent]');
          if (badge) badge.textContent = badge.textContent.replace(/[\d.,]+/, plan.percent);
          if (perk) perk.textContent = perk.textContent.replace(/[\d.,]+/, plan.percent);
        }

        // The button always states what will actually be charged.
        if (submitPrice) submitPrice.textContent = plan ? plan.priceText : v.priceText;

        /* Both cards restate the pack you actually chose, on two lines: which
           pack and how many, then what that works out to per day. The one-off
           card quotes its own rate, so the two are directly comparable rather
           than one borrowing the other's number. */
        var rateOf = function (perDay) {
          if (!perDay) return '';
          return dayLabel ? dayLabel.replace('[price]', perDay) : perDay;
        };

        setText('[data-pdp-sub-size]', v.sizeText || '');
        /* "1 Monat" reads as "jeden Monat"; every other pack as "alle 2 Monate". */
        var everyEl = root.querySelector('[data-pdp-sub-every]');
        /* Leads with how many bags come: "1 Packung jeden Monat",
           "2 Packungen alle 2 Monate", "3 Packungen einmalig". */
        var packs = parseInt(v.sizeText, 10);
        var packsText = '';
        if (everyEl && packs) {
          packsText =
            packs === 1 ? everyEl.dataset.packOne || '' : (everyEl.dataset.packMany || '').replace('[n]', packs);
        }
        if (everyEl && v.sizeText) {
          everyEl.textContent =
            (packsText ? packsText + ' ' : '') +
            (packs === 1 ? everyEl.dataset.monthly || '' : (everyEl.dataset.every || '').replace('[size]', v.sizeText));
        }
        var onceEl = root.querySelector('[data-pdp-once-every]');
        if (onceEl) onceEl.textContent = (packsText ? packsText + ' ' : '') + (onceEl.dataset.once || '');
        setText('[data-pdp-sub-count]', v.countText || '');
        setText('[data-pdp-sub-day]', rateOf(plan ? plan.perDayText : v.perDayText));

        setText('[data-pdp-once-size]', v.sizeText || '');
        setText('[data-pdp-once-count]', v.countText || '');
        setText('[data-pdp-once-day]', rateOf(v.perDayText));
        var savingEl = root.querySelector('[data-pdp-sub-saving]');
        if (savingEl) {
          savingEl.textContent = plan && plan.savingText ? savingLabel.replace('[amount]', plan.savingText) : '';
        }

        /* Every size card restates its per-day price for the mode in play, so
           the comparison between packs is like-for-like and never quotes the
           one-time rate while the subscription is selected. */
        if (sizesField) {
          variants.forEach(function (item) {
            var el = root.querySelector('[data-pdp-size-day="' + item.id + '"]');
            if (!el) return;

            /* Every pack size carries its own selling-plan group, so the plan
               id selected for the size currently showing does not exist on any
               of the others. Looking it up by id and giving up returned each
               other size's *one-time* rate while the selected one showed its
               subscription rate — which is how a bigger pack came to quote a
               higher price per day than a smaller one. Fall back to that size's
               own plan instead, so the row compares like with like. */
            var itemPlan = null;
            if (planId && item.plans) {
              itemPlan = item.plans[planId] || null;
              if (!itemPlan) {
                var ownPlans = Object.keys(item.plans);
                if (ownPlans.length) itemPlan = item.plans[ownPlans[0]];
              }
            }

            var text = itemPlan ? itemPlan.perDayText : item.perDayText;
            if (text) el.textContent = dayLabel.replace('[price]', text);
          });
        }

        /* The sticky bar is a second face on the same state, never its own.
           The plan name, the discount badge and the struck one-off price only
           exist while a subscription is selected — hidden rather than blanked,
           so the row closes up instead of leaving three gaps. */
        setText('[data-pdp-bar-price]', plan ? plan.priceText : v.priceText);
        // Same two figures again, inside the button, for the phone layout.
        setText('[data-pdp-bar-cta-price]', plan ? plan.priceText : v.priceText);
        setText('[data-pdp-bar-count]', v.countText || '');

        var barDay = plan ? plan.perDayText : v.perDayText;
        var hasDay = !!(v.hasPerDay && barDay);
        // Products without a pack-size option never render the fieldset that
        // carries the phrasing, so the bare figure stands in for it there.
        setText('[data-pdp-bar-unit]', hasDay ? (dayLabel ? dayLabel.replace('[price]', barDay) : barDay) : '');

        var barMeta = root.querySelector('.pdp__bar-meta');
        if (barMeta) barMeta.hidden = !v.countText && !hasDay;

        var barPlan = root.querySelector('[data-pdp-bar-plan]');
        if (barPlan) barPlan.hidden = !plan;

        var barBadge = root.querySelector('[data-pdp-bar-badge]');
        if (barBadge) {
          var hasPercent = !!(plan && plan.percent);
          barBadge.hidden = !hasPercent;
          if (hasPercent) barBadge.textContent = savePercentLabel.replace('[percent]', plan.percent);
        }

        // A plan with no actual reduction has nothing to strike through.
        var hasWas = !!(plan && plan.wasText && plan.wasText !== plan.priceText);
        [root.querySelector('[data-pdp-bar-was]'), root.querySelector('[data-pdp-bar-cta-was]')].forEach(function (el) {
          if (!el) return;
          el.hidden = !hasWas;
          if (hasWas) el.textContent = plan.wasText;
        });

        var barVariant = root.querySelector('[data-pdp-bar-variant]');
        if (barVariant && v.options && v.options[0] && v.options[0] !== 'Default Title') {
          barVariant.textContent = '– ' + v.options.join(' / ');
        }
      }

      /* Reveal the bar once the real buy box has left the viewport. An observer
         rather than a scroll handler: the browser reports the crossing itself,
         so there is no work on every scroll frame. */
      /* The gallery clip opens as a poster: no controls, a scrim and one button.
         Both the controls and the scrim change state on the first press, which
         is the point at which either of them is worth anything. */
      var videoTile = root.querySelector('[data-pdp-video]');
      if (videoTile) {
        var galleryVideo = videoTile.querySelector('video');
        var galleryPlay = videoTile.querySelector('[data-pdp-video-play]');

        if (galleryVideo && galleryPlay) {
          galleryPlay.addEventListener('click', function () {
            videoTile.classList.add('is-playing');
            galleryVideo.controls = true;
            galleryPlay.hidden = true;

            var started = galleryVideo.play();
            // Autoplay policy can refuse; put the affordance back rather than
            // leaving a clip that looks broken.
            if (started && typeof started.catch === 'function') {
              started.catch(function () {
                videoTile.classList.remove('is-playing');
                galleryVideo.controls = false;
                galleryPlay.hidden = false;
              });
            }
          });

          // Back to the poster once it finishes, so the section reads the same
          // on a second visit as it did on the first.
          galleryVideo.addEventListener('ended', function () {
            videoTile.classList.remove('is-playing');
            galleryVideo.controls = false;
            galleryPlay.hidden = false;
          });
        }
      }

      var bar = root.querySelector('[data-pdp-bar]');
      var buybox = root.querySelector('.pdp__buy');
      if (bar && buybox && 'IntersectionObserver' in window) {
        bar.hidden = false;

        /* A fixed element reserves no space, so the page has to reserve it
           instead — without this the bar sits on top of the last rows of the
           footer for the whole of the lower page, and on a phone that is a
           sixth of the viewport permanently covered. The measurement is taken
           from the bar itself and refreshed whenever it reflows, so a rotation
           or a breakpoint that restacks it stays correct. */
        var reserveSpace = function () {
          document.documentElement.style.setProperty('--pdp-bar-height', bar.offsetHeight + 'px');
        };
        reserveSpace();
        if ('ResizeObserver' in window) {
          new ResizeObserver(reserveSpace).observe(bar);
        } else {
          window.addEventListener('resize', reserveSpace);
        }

        /* Off-screen it is still a submit button in the tab order and still
           read out by a screen reader — a second "add to cart" with no
           indication of which one is live. `inert` takes the whole bar out
           while it is parked and hands it back when it arrives. */
        var setVisible = function (visible) {
          bar.classList.toggle('is-visible', visible);
          if ('inert' in bar) bar.inert = !visible;
          else bar.setAttribute('aria-hidden', visible ? 'false' : 'true');
        };
        setVisible(false);

        var barObserver = new IntersectionObserver(
          function (entries) {
            entries.forEach(function (entry) {
              // Below the buy box, not above it — the bar should not appear
              // while the reader is still scrolling down towards the CTA.
              var below = entry.boundingClientRect.top < 0;
              setVisible(!entry.isIntersecting && below);
            });
          },
          { rootMargin: '0px 0px -20% 0px' },
        );
        barObserver.observe(buybox);
      }

      // Kept as the old name so the rest of this file still calls it.
      var sync = render;

      root.querySelectorAll('[data-pdp-option]').forEach(function (input) {
        input.addEventListener('change', render);
      });

      root.querySelectorAll('[data-pdp-choice]').forEach(function (radio) {
        radio.addEventListener('change', sync);
      });
      sync();
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["social-gallery"] && !Shopify.designMode) return;
  try {
    
  class VideoGallery extends HTMLElement {
    // The dialog lives on <body> while the section is on the page; take it
    // (and the key listener) with us when the section is removed, e.g. when
    // the theme editor re-renders it.
    disconnectedCallback() {
      if (this._onKey) document.removeEventListener('keydown', this._onKey);
      if (this.modal && this.modal.parentNode === document.body) this.modal.remove();
      document.body.style.overflow = '';
    }

    connectedCallback() {
      this.modal = this.querySelector('.vg');
      if (!this.modal) return;
      // Move the dialog to <body>: inside the section it inherits the
      // section's stacking context and ends up under the sticky header.
      document.body.appendChild(this.modal);
      this.triggers = Array.from(this.querySelectorAll('.social__open'));
      this.items = this.triggers.map((t) => ({ ...t.dataset }));
      this.index = 0;

      this.video = this.modal.querySelector('.vg__video');
      this.handleEl = this.modal.querySelector('.vg__handle');
      this.progressBar = this.modal.querySelector('.vg__progress-bar');
      this.muteBtn = this.modal.querySelector('.vg__mute');
      this.pTitle = this.modal.querySelector('.vg__product-title');
      this.pPrice = this.modal.querySelector('.vg__product-price');
      this.desc = this.modal.querySelector('.vg__desc');
      this.moreBtn = this.modal.querySelector('.vg__more');
      this.addBtn = this.modal.querySelector('.vg__add');
      this.galleryImgs = this.modal.querySelectorAll('.vg__gallery-img');
      this.galleryTrack = this.modal.querySelector('.vg__gallery-track');
      this.dots = this.modal.querySelectorAll('.vg__dot');
      this.galleryIndex = 0;
      this.qty = 1;
      this.qtyVal = this.modal.querySelector('[data-vg-qval]');
      this.scroll = this.modal.querySelector('.vg__panel-scroll');
      this.peekPrev = this.modal.querySelector('.vg__peek--prev video');
      this.peekNext = this.modal.querySelector('.vg__peek--next video');

      // Product gallery
      this.modal.querySelector('[data-vg-gprev]').addEventListener('click', () => this.galleryGo(-1));
      this.modal.querySelector('[data-vg-gnext]').addEventListener('click', () => this.galleryGo(1));
      // Variant chips (visual selection only)
      this.modal.querySelectorAll('[data-vg-chipgroup]').forEach((group) => {
        group.addEventListener('click', (e) => {
          const chip = e.target.closest('.vg__chip');
          if (!chip) return;
          group.querySelectorAll('.vg__chip').forEach((c) => c.classList.remove('is-selected'));
          chip.classList.add('is-selected');
        });
      });
      // Quantity stepper
      this.modal.querySelector('[data-vg-qminus]').addEventListener('click', () => {
        this.qty = Math.max(1, this.qty - 1);
        this.qtyVal.textContent = this.qty;
      });
      this.modal.querySelector('[data-vg-qplus]').addEventListener('click', () => {
        this.qty += 1;
        this.qtyVal.textContent = this.qty;
      });

      // Grid previews: play muted only while hovering the card
      this.triggers.forEach((t) => {
        const v = t.querySelector('.social__video');
        if (!v) return;
        v.addEventListener('loadeddata', function once() {
          try {
            if (v.paused) v.currentTime = 0.1;
          } catch (e) {}
          v.removeEventListener('loadeddata', once);
        });
        t.addEventListener('mouseenter', () => {
          v.play().catch(() => {});
        });
        t.addEventListener('mouseleave', () => {
          v.pause();
          try {
            v.currentTime = 0.1;
          } catch (e) {}
        });
      });

      this.triggers.forEach((t, i) => t.addEventListener('click', () => this.open(i)));
      this.modal.querySelectorAll('[data-vg-close]').forEach((el) => el.addEventListener('click', () => this.close()));
      // The stage covers the backdrop, so a tap on its empty area (anywhere
      // outside the card, arrows and peeks) is the "tap outside" close.
      this.modal.querySelector('.vg__stage').addEventListener('click', (event) => {
        if (event.target === event.currentTarget) this.close();
      });
      this.modal.querySelector('[data-vg-prev]').addEventListener('click', () => this.go(-1));
      this.modal.querySelector('[data-vg-next]').addEventListener('click', () => this.go(1));
      this.muteBtn.addEventListener('click', () => this.toggleMute());
      this.video.addEventListener('click', () => {
        if (this._swiped) {
          this._swiped = false;
          return;
        }
        this.togglePlay();
      });
      // Swipe left/right on the video to move between clips (touch). A clear
      // horizontal intent (40px, more sideways than vertical) is required, so
      // vertical scrolling and taps are never misread.
      const wrap = this.video.parentElement;
      wrap.addEventListener(
        'pointerdown',
        (e) => {
          if (e.pointerType === 'mouse') return;
          this._sx = e.clientX;
          this._sy = e.clientY;
        },
        { passive: true },
      );
      wrap.addEventListener(
        'pointerup',
        (e) => {
          if (e.pointerType === 'mouse' || this._sx == null) return;
          const dx = e.clientX - this._sx;
          const dy = e.clientY - this._sy;
          this._sx = null;
          if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy) * 1.2) {
            this._swiped = true;
            this.go(dx < 0 ? 1 : -1);
          }
        },
        { passive: true },
      );
      this.video.addEventListener('timeupdate', () => this.updateProgress());
      this.peekPrev.parentElement.addEventListener('click', () => this.go(-1));
      this.peekNext.parentElement.addEventListener('click', () => this.go(1));

      this._onKey = (e) => {
        if (this.modal.hidden) return;
        if (e.key === 'Escape') {
          this._closedByKey = true;
          this.close();
        } else if (e.key === 'ArrowRight') this.go(1);
        else if (e.key === 'ArrowLeft') this.go(-1);
        else if (e.key === 'Tab') this._trapFocus(e);
      };
      document.addEventListener('keydown', this._onKey);
    }

    open(i) {
      if (!this.items[i] || !this.items[i].video) return;
      this.index = i;

      // Remember who opened this so focus can go back there on close, and so
      // the card can grow out of the thumbnail rather than out of nowhere.
      this.opener = this.triggers[i] || document.activeElement;
      this._anchorTo(this.opener);

      this.modal.hidden = false;
      document.body.style.overflow = 'hidden';
      this.render(true);

      // One frame with the closed state applied, so the transition to
      // .is-open actually animates instead of being collapsed away.
      requestAnimationFrame(() => {
        requestAnimationFrame(() => this.modal.classList.add('is-open'));
      });

      const closeBtn = this.modal.querySelector('.vg__close');
      if (closeBtn) closeBtn.focus({ preventScroll: true });
    }

    close() {
      if (this.modal.hidden) return;
      this.modal.classList.remove('is-open');
      this.video.pause();

      // Wait for the exit to finish before hiding, so the card retracts
      // toward its origin instead of vanishing. Falls back to a timer if the
      // transition never fires (reduced motion neutralises the duration).
      const finish = () => {
        this.modal.hidden = true;
        document.body.style.overflow = '';
        clearTimeout(this._closeTimer);
      };
      const card = this.modal.querySelector('.vg__card');
      if (card) {
        card.addEventListener('transitionend', finish, { once: true });
      }
      this._closeTimer = setTimeout(finish, 400);

      // Hand focus back to the card that opened the video (for keyboard and
      // screen-reader users), but without a focus ring when the video was
      // closed by touch or mouse — a ring there reads as a glitch.
      if (this.opener && document.contains(this.opener)) {
        const opener = this.opener;
        if (!this._closedByKey) {
          opener.classList.add('is-quiet-focus');
          opener.addEventListener('blur', () => opener.classList.remove('is-quiet-focus'), { once: true });
        }
        opener.focus({ preventScroll: true, focusVisible: !!this._closedByKey });
      }
      this._closedByKey = false;
    }

    // Point the card's transform-origin at the element that opened it, as a
    // percentage of the card's own box, so it appears to expand from there.
    _anchorTo(trigger) {
      const card = this.modal.querySelector('.vg__card');
      if (!card || !trigger || !trigger.getBoundingClientRect) return;
      const t = trigger.getBoundingClientRect();
      const originX = ((t.left + t.width / 2) / window.innerWidth) * 100;
      const originY = ((t.top + t.height / 2) / window.innerHeight) * 100;
      card.style.setProperty('--vg-origin-x', originX.toFixed(1) + '%');
      card.style.setProperty('--vg-origin-y', originY.toFixed(1) + '%');
    }

    // Keep Tab inside the dialog — a modal that lets focus wander behind the
    // scrim strands keyboard users with no way back.
    _trapFocus(e) {
      const focusables = this.modal.querySelectorAll(
        'button:not([disabled]), a[href], video[controls], [tabindex]:not([tabindex="-1"])',
      );
      if (!focusables.length) return;
      const first = focusables[0];
      const last = focusables[focusables.length - 1];
      if (e.shiftKey && document.activeElement === first) {
        e.preventDefault();
        last.focus();
      } else if (!e.shiftKey && document.activeElement === last) {
        e.preventDefault();
        first.focus();
      }
    }

    go(delta) {
      const n = this.items.length;
      this.index = (this.index + delta + n) % n;
      this.render(true);
    }

    toggleMute() {
      this.video.muted = !this.video.muted;
      this.muteBtn.classList.toggle('is-muted', this.video.muted);
    }

    togglePlay() {
      if (this.video.paused) this.video.play();
      else this.video.pause();
    }

    updateProgress() {
      if (this.video.duration) {
        this.progressBar.style.transform = 'scaleX(' + this.video.currentTime / this.video.duration + ')';
      }
    }

    render(withSound) {
      const it = this.items[this.index];
      this.video.src = it.video;
      this.video.currentTime = 0;
      this.progressBar.style.transform = 'scaleX(0)';
      this.video.muted = false;
      const p = this.video.play();
      if (p && p.catch) {
        p.catch(() => {
          this.video.muted = true;
          this.muteBtn.classList.add('is-muted');
          this.video.play().catch(() => {});
        });
      }
      this.muteBtn.classList.toggle('is-muted', this.video.muted);

      this.handleEl.textContent = it.handle || '';
      this.pTitle.textContent = it.ptitle || '';
      this.pPrice.textContent = it.pprice || '';
      this.desc.textContent = it.pdesc || '';
      this.moreBtn.setAttribute('href', it.plink || this.moreBtn.getAttribute('href'));
      this.addBtn.setAttribute('href', it.plink || this.addBtn.getAttribute('href'));
      // A product link opens the quick-buy window instead of leaving the page.
      if (it.plink && it.plink.indexOf('/products/') !== -1) this.addBtn.dataset.quickBuy = it.plink;
      else delete this.addBtn.dataset.quickBuy;

      // Product image gallery (same image across slides for now)
      this.galleryImgs.forEach((img) => {
        if (it.pimage) img.src = it.pimage;
      });
      this.galleryIndex = 0;
      this._updateGallery();
      this.qty = 1;
      this.qtyVal.textContent = '1';
      if (this.scroll) this.scroll.scrollTop = 0;

      const n = this.items.length;
      this._setPeek(this.peekPrev, this.items[(this.index - 1 + n) % n].video);
      this._setPeek(this.peekNext, this.items[(this.index + 1) % n].video);
    }

    galleryGo(delta) {
      const n = this.galleryImgs.length;
      this.galleryIndex = (this.galleryIndex + delta + n) % n;
      this._updateGallery();
    }

    _updateGallery() {
      this.galleryTrack.style.transform = 'translateX(-' + this.galleryIndex * 100 + '%)';
      this.dots.forEach((d, i) => d.classList.toggle('is-active', i === this.galleryIndex));
    }

    _setPeek(v, src) {
      if (!v || !src || v.dataset.loaded === src) return;
      v.dataset.loaded = src;
      v.src = src;
      v.muted = true;
      v.addEventListener('loadeddata', function once() {
        try {
          v.currentTime = 0.4;
        } catch (e) {}
        v.removeEventListener('loadeddata', once);
      });
      v.load();
    }
  }

  if (!customElements.get('video-gallery')) {
    customElements.define('video-gallery', VideoGallery);
  }

  /* Arrow controls for the video shelf on tablets and phones. Scrolling stays
     native; the arrows move one card and hide at either end. */
  class SocialShelf extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('.social__grid');
      this.prev = this.querySelector('[data-dir="-1"]');
      this.next = this.querySelector('[data-dir="1"]');
      if (!this.track || !this.prev || !this.next) return;
      this.onClick = (event) => {
        const dir = Number(event.currentTarget.dataset.dir);
        const card = this.track.querySelector('.social__card');
        const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
        const step = card ? card.getBoundingClientRect().width + gap : this.track.clientWidth * 0.6;
        const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.track.scrollBy({ left: dir * step, behavior: reduce ? 'auto' : 'smooth' });
      };
      this.update = () => {
        this.frame = null;
        const max = this.track.scrollWidth - this.track.clientWidth;
        this.prev.disabled = this.track.scrollLeft <= 4;
        this.next.disabled = this.track.scrollLeft >= max - 4;
      };
      this.onScroll = () => {
        if (!this.frame) this.frame = requestAnimationFrame(this.update);
      };
      this.prev.addEventListener('click', this.onClick);
      this.next.addEventListener('click', this.onClick);
      this.track.addEventListener('scroll', this.onScroll, { passive: true });
      this.resizeObserver = new ResizeObserver(this.update);
      this.resizeObserver.observe(this.track);
      this.update();
    }
    disconnectedCallback() {
      this.track?.removeEventListener('scroll', this.onScroll);
      this.resizeObserver?.disconnect();
    }
  }
  if (!customElements.get('social-shelf')) {
    customElements.define('social-shelf', SocialShelf);
  }

  } catch(e) { console.error(e); }
})();
})();
